import { baseApi as api } from '../../store/api/baseApi';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    appControllerGetHello: build.query<
      AppControllerGetHelloApiResponse,
      AppControllerGetHelloApiArg
    >({
      query: () => ({ url: `/` }),
    }),
    metricsControllerWebhook: build.query<
      MetricsControllerWebhookApiResponse,
      MetricsControllerWebhookApiArg
    >({
      query: () => ({ url: `/metrics` }),
    }),
    refreshTokensControllerRefreshTokenUser: build.mutation<
      RefreshTokensControllerRefreshTokenUserApiResponse,
      RefreshTokensControllerRefreshTokenUserApiArg
    >({
      query: () => ({ url: `/v1/user/refresh-token`, method: 'POST' }),
    }),
    refreshTokensControllerRefreshTokenAdmin: build.mutation<
      RefreshTokensControllerRefreshTokenAdminApiResponse,
      RefreshTokensControllerRefreshTokenAdminApiArg
    >({
      query: () => ({ url: `/v1/admin/refresh-token`, method: 'POST' }),
    }),
    signInControllerSignInUser: build.mutation<
      SignInControllerSignInUserApiResponse,
      SignInControllerSignInUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/user/sign-in`,
        method: 'POST',
        body: queryArg.signInRequestDto,
      }),
    }),
    signInControllerSignInAdmin: build.mutation<
      SignInControllerSignInAdminApiResponse,
      SignInControllerSignInAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/admin/sign-in`,
        method: 'POST',
        body: queryArg.signInRequestDto,
      }),
    }),
    apiKeyControllerGetSystemApiKeyInfo: build.query<
      ApiKeyControllerGetSystemApiKeyInfoApiResponse,
      ApiKeyControllerGetSystemApiKeyInfoApiArg
    >({
      query: (queryArg) => ({ url: `/v1/system/api-keys/${queryArg.jti}` }),
    }),
    forgotPasswordControllerForgotPassword: build.mutation<
      ForgotPasswordControllerForgotPasswordApiResponse,
      ForgotPasswordControllerForgotPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/user/forgot-password`,
        method: 'POST',
        body: queryArg.forgotPasswordRequestDto,
      }),
    }),
    resetPasswordControllerResetPassword: build.mutation<
      ResetPasswordControllerResetPasswordApiResponse,
      ResetPasswordControllerResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/user/reset-password`,
        method: 'POST',
        body: queryArg.resetPasswordRequestDto,
      }),
    }),
    userMeControllerUserMe: build.query<
      UserMeControllerUserMeApiResponse,
      UserMeControllerUserMeApiArg
    >({
      query: () => ({ url: `/v1/users/me` }),
    }),
    getUsersListControllerGetUsersList: build.query<
      GetUsersListControllerGetUsersListApiResponse,
      GetUsersListControllerGetUsersListApiArg
    >({
      query: (queryArg) => ({ url: `/v1/companies/${queryArg.id}/users-list` }),
    }),
    editUserControllerEditUser: build.mutation<
      EditUserControllerEditUserApiResponse,
      EditUserControllerEditUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/user/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.editUserRequestDto,
      }),
    }),
    userCreateControllerCreateUser: build.mutation<
      UserCreateControllerCreateUserApiResponse,
      UserCreateControllerCreateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/users`,
        method: 'POST',
        body: queryArg.userCreateRequestDto,
      }),
    }),
    adminMeControllerAdminMe: build.query<
      AdminMeControllerAdminMeApiResponse,
      AdminMeControllerAdminMeApiArg
    >({
      query: () => ({ url: `/v1/admins/me` }),
    }),
    analysisStaleSweepControllerSystemAnalysisStaleSweep: build.mutation<
      AnalysisStaleSweepControllerSystemAnalysisStaleSweepApiResponse,
      AnalysisStaleSweepControllerSystemAnalysisStaleSweepApiArg
    >({
      query: () => ({ url: `/v2/system/analyses/sweep`, method: 'POST' }),
    }),
    callAnalysisCreateControllerSystemCreateCallAnalysis: build.mutation<
      CallAnalysisCreateControllerSystemCreateCallAnalysisApiResponse,
      CallAnalysisCreateControllerSystemCreateCallAnalysisApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}/analyses`,
        method: 'POST',
        body: queryArg.callAnalysisCreateRequestDto,
      }),
    }),
    callSentimentCreateControllerCreateCallSentiment: build.mutation<
      CallSentimentCreateControllerCreateCallSentimentApiResponse,
      CallSentimentCreateControllerCreateCallSentimentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}/sentiments`,
        method: 'POST',
        body: queryArg.sentimentRequestDto,
      }),
    }),
    callUpdateControllerSystemCallUpdate: build.mutation<
      CallUpdateControllerSystemCallUpdateApiResponse,
      CallUpdateControllerSystemCallUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.callRequestDto,
      }),
    }),
    callControllerSystemGetCallById: build.query<
      CallControllerSystemGetCallByIdApiResponse,
      CallControllerSystemGetCallByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}`,
        params: { relations: queryArg.relations },
      }),
    }),
    callSupervisorModeControllerSetSupervisorMode: build.mutation<
      CallSupervisorModeControllerSetSupervisorModeApiResponse,
      CallSupervisorModeControllerSetSupervisorModeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/calls/${queryArg.id}/supervisor/mode`,
        method: 'PATCH',
        body: queryArg.callSupervisorModeRequestDto,
      }),
    }),
    callStaleSweepControllerSystemStaleSweep: build.mutation<
      CallStaleSweepControllerSystemStaleSweepApiResponse,
      CallStaleSweepControllerSystemStaleSweepApiArg
    >({
      query: () => ({ url: `/v2/system/calls/stale-sweep`, method: 'POST' }),
    }),
    campaignTestCallCreateControllerTestCallCreate: build.mutation<
      CampaignTestCallCreateControllerTestCallCreateApiResponse,
      CampaignTestCallCreateControllerTestCallCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/calls`,
        method: 'POST',
        body: queryArg.campaignTestCallCreateRequestDto,
      }),
    }),
    campaignCallListControllerCallList: build.query<
      CampaignCallListControllerCallListApiResponse,
      CampaignCallListControllerCallListApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/calls`,
        params: {
          statuses: queryArg.statuses,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          types: queryArg.types,
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
        },
      }),
    }),
    campaignTestCallCreateControllerExternalTestCallCreate: build.mutation<
      CampaignTestCallCreateControllerExternalTestCallCreateApiResponse,
      CampaignTestCallCreateControllerExternalTestCallCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external/campaigns/${queryArg.id}/calls`,
        method: 'POST',
        body: queryArg.campaignTestCallCreateRequestDto,
      }),
    }),
    callCreateExternalControllerCampaignOutboundCall: build.mutation<
      CallCreateExternalControllerCampaignOutboundCallApiResponse,
      CallCreateExternalControllerCampaignOutboundCallApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external/campaigns/${queryArg.id}/outbound-calls`,
        method: 'POST',
        body: queryArg.callCreateExternalRequestDto,
      }),
    }),
    campaignCallHangupControllerCampaignCallHangup: build.mutation<
      CampaignCallHangupControllerCampaignCallHangupApiResponse,
      CampaignCallHangupControllerCampaignCallHangupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/calls/${queryArg.callId}/hangup`,
        method: 'POST',
      }),
    }),
    campaignCallHangupControllerExternalCampaignCallHangup: build.mutation<
      CampaignCallHangupControllerExternalCampaignCallHangupApiResponse,
      CampaignCallHangupControllerExternalCampaignCallHangupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external/campaigns/${queryArg.id}/calls/${queryArg.callId}/hangup`,
        method: 'POST',
      }),
    }),
    campaignCloneSystemControllerCloneCampaign: build.mutation<
      CampaignCloneSystemControllerCloneCampaignApiResponse,
      CampaignCloneSystemControllerCloneCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.campaignId}/clone`,
        method: 'POST',
        body: queryArg.campaignCloneRequestDto,
      }),
    }),
    campaignCreateControllerCampaignCreate: build.mutation<
      CampaignCreateControllerCampaignCreateApiResponse,
      CampaignCreateControllerCampaignCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns`,
        method: 'POST',
        body: queryArg.campaignCreateRequestDto,
      }),
    }),
    campaignListControllerCampaignList: build.query<
      CampaignListControllerCampaignListApiResponse,
      CampaignListControllerCampaignListApiArg
    >({
      query: () => ({ url: `/v2/campaigns` }),
    }),
    campaignDeleteControllerDeleteCampaign: build.mutation<
      CampaignDeleteControllerDeleteCampaignApiResponse,
      CampaignDeleteControllerDeleteCampaignApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}`, method: 'DELETE' }),
    }),
    campaignUpdateControllerCampaignUpdate: build.mutation<
      CampaignUpdateControllerCampaignUpdateApiResponse,
      CampaignUpdateControllerCampaignUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.campaignUpdateRequestDto,
      }),
    }),
    campaignControllerCampaign: build.query<
      CampaignControllerCampaignApiResponse,
      CampaignControllerCampaignApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}` }),
    }),
    campaignIntegrationSchedulerRunControllerSystemRunIntegrationScheduler: build.mutation<
      CampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerApiResponse,
      CampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerApiArg
    >({
      query: () => ({ url: `/v2/system/campaigns/run-integration-scheduler`, method: 'POST' }),
    }),
    campaignAnalysisBatchRunControllerSystemRunAnalysisBatch: build.mutation<
      CampaignAnalysisBatchRunControllerSystemRunAnalysisBatchApiResponse,
      CampaignAnalysisBatchRunControllerSystemRunAnalysisBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.id}/run-analysis-batch`,
        method: 'POST',
      }),
    }),
    campaignStructuredOutputGenerateControllerGenerate: build.mutation<
      CampaignStructuredOutputGenerateControllerGenerateApiResponse,
      CampaignStructuredOutputGenerateControllerGenerateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/structured-output/generate`,
        method: 'POST',
      }),
    }),
    campaignOutboundCallsProcessControllerSystemOutboundCallsProcess: build.mutation<
      CampaignOutboundCallsProcessControllerSystemOutboundCallsProcessApiResponse,
      CampaignOutboundCallsProcessControllerSystemOutboundCallsProcessApiArg
    >({
      query: () => ({ url: `/v2/system/campaigns/outbound-calls-process`, method: 'POST' }),
    }),
    campaignCompletionSweepControllerSystemCompletionSweep: build.mutation<
      CampaignCompletionSweepControllerSystemCompletionSweepApiResponse,
      CampaignCompletionSweepControllerSystemCompletionSweepApiArg
    >({
      query: () => ({ url: `/v2/system/campaigns/completion-sweep`, method: 'POST' }),
    }),
    campaignRunControllerCampaignRun: build.mutation<
      CampaignRunControllerCampaignRunApiResponse,
      CampaignRunControllerCampaignRunApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/run`, method: 'POST' }),
    }),
    campaignSipTrunkCreateControllerCampaignCreate: build.mutation<
      CampaignSipTrunkCreateControllerCampaignCreateApiResponse,
      CampaignSipTrunkCreateControllerCampaignCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/sip-trunk`,
        method: 'POST',
        body: queryArg.campaignSipTrunkCreateRequestDto,
      }),
    }),
    campaignSipTrunkControllerGetSipTrunk: build.query<
      CampaignSipTrunkControllerGetSipTrunkApiResponse,
      CampaignSipTrunkControllerGetSipTrunkApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/sip-trunk` }),
    }),
    campaignStopControllerCampaignStop: build.mutation<
      CampaignStopControllerCampaignStopApiResponse,
      CampaignStopControllerCampaignStopApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/stop`, method: 'POST' }),
    }),
    campaignsStopExceededLimitsControllerStopExceededLimits: build.mutation<
      CampaignsStopExceededLimitsControllerStopExceededLimitsApiResponse,
      CampaignsStopExceededLimitsControllerStopExceededLimitsApiArg
    >({
      query: () => ({ url: `/v2/system/campaigns/stop-exceeded-limits`, method: 'POST' }),
    }),
    customerUpdateControllerUpdateCustomer: build.mutation<
      CustomerUpdateControllerUpdateCustomerApiResponse,
      CustomerUpdateControllerUpdateCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/customers/${queryArg.customerId}`,
        method: 'PATCH',
        body: queryArg.customerUpdateRequestDto,
      }),
    }),
    campaignAgentCreateControllerExecute: build.mutation<
      CampaignAgentCreateControllerExecuteApiResponse,
      CampaignAgentCreateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/agents`,
        method: 'POST',
        body: queryArg.agentRequestDto,
      }),
    }),
    campaignAgentListControllerList: build.query<
      CampaignAgentListControllerListApiResponse,
      CampaignAgentListControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/agents` }),
    }),
    campaignAgentUpdateControllerExecute: build.mutation<
      CampaignAgentUpdateControllerExecuteApiResponse,
      CampaignAgentUpdateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/agents/${queryArg.agentId}`,
        method: 'PUT',
        body: queryArg.agentRequestDto,
      }),
    }),
    campaignAgentDeleteControllerExecute: build.mutation<
      CampaignAgentDeleteControllerExecuteApiResponse,
      CampaignAgentDeleteControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/agents/${queryArg.agentId}`,
        method: 'DELETE',
      }),
    }),
    callActionCreateControllerSystemCallActionCreate: build.mutation<
      CallActionCreateControllerSystemCallActionCreateApiResponse,
      CallActionCreateControllerSystemCallActionCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}/actions`,
        method: 'POST',
        body: queryArg.callActionRequestDto,
      }),
    }),
    callCreateSystemControllerSystemCampaignCallCreate: build.mutation<
      CallCreateSystemControllerSystemCampaignCallCreateApiResponse,
      CallCreateSystemControllerSystemCampaignCallCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.id}/calls`,
        method: 'POST',
        body: queryArg.callCreateSystemRequestDto,
      }),
    }),
    callControllerGetCallById: build.query<
      CallControllerGetCallByIdApiResponse,
      CallControllerGetCallByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/calls/${queryArg.id}`,
        params: { relations: queryArg.relations },
      }),
    }),
    campaignControllerSystemCampaign: build.query<
      CampaignControllerSystemCampaignApiResponse,
      CampaignControllerSystemCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.id}`,
        params: { relations: queryArg.relations },
      }),
    }),
    campaignCallControllerCall: build.query<
      CampaignCallControllerCallApiResponse,
      CampaignCallControllerCallApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/calls/${queryArg.callId}` }),
    }),
    campaignCallListPaginatedControllerCallListPaginated: build.query<
      CampaignCallListPaginatedControllerCallListPaginatedApiResponse,
      CampaignCallListPaginatedControllerCallListPaginatedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/calls/paginated`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          sortOrder: queryArg.sortOrder,
          statuses: queryArg.statuses,
          sortBy: queryArg.sortBy,
          types: queryArg.types,
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          withTotal: queryArg.withTotal,
        },
      }),
    }),
    campaignFileListControllerList: build.query<
      CampaignFileListControllerListApiResponse,
      CampaignFileListControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/files` }),
    }),
    campaignListControllerExternalCampaignList: build.query<
      CampaignListControllerExternalCampaignListApiResponse,
      CampaignListControllerExternalCampaignListApiArg
    >({
      query: () => ({ url: `/v2/external/campaigns` }),
    }),
    campaignListPaginatedControllerGetCampaignListPaginated: build.query<
      CampaignListPaginatedControllerGetCampaignListPaginatedApiResponse,
      CampaignListPaginatedControllerGetCampaignListPaginatedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/paginated`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          sortOrder: queryArg.sortOrder,
          sortBy: queryArg.sortBy,
          withTotal: queryArg.withTotal,
          search: queryArg.search,
        },
      }),
    }),
    campaignMetricCallDurationControllerCalculateCallDurationIqr: build.query<
      CampaignMetricCallDurationControllerCalculateCallDurationIqrApiResponse,
      CampaignMetricCallDurationControllerCalculateCallDurationIqrApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/metrics/call-duration/interquartile-range`,
      }),
    }),
    campaignReportControllerUserCampaignsReport: build.query<
      CampaignReportControllerUserCampaignsReportApiResponse,
      CampaignReportControllerUserCampaignsReportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/reports`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          types: queryArg.types,
          statuses: queryArg.statuses,
          additionalColumns: queryArg.additionalColumns,
          separatedAnalysisSummary: queryArg.separatedAnalysisSummary,
        },
      }),
    }),
    campaignReportControllerUserCampaignReport: build.query<
      CampaignReportControllerUserCampaignReportApiResponse,
      CampaignReportControllerUserCampaignReportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/reports`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          types: queryArg.types,
          statuses: queryArg.statuses,
          additionalColumns: queryArg.additionalColumns,
          separatedAnalysisSummary: queryArg.separatedAnalysisSummary,
        },
      }),
    }),
    campaignReportControllerAdminCampaignsReport: build.query<
      CampaignReportControllerAdminCampaignsReportApiResponse,
      CampaignReportControllerAdminCampaignsReportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/campaigns/reports`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          types: queryArg.types,
          statuses: queryArg.statuses,
          additionalColumns: queryArg.additionalColumns,
          separatedAnalysisSummary: queryArg.separatedAnalysisSummary,
        },
      }),
    }),
    campaignReportControllerAdminCampaignReport: build.query<
      CampaignReportControllerAdminCampaignReportApiResponse,
      CampaignReportControllerAdminCampaignReportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/campaigns/${queryArg.id}/reports`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          types: queryArg.types,
          statuses: queryArg.statuses,
          additionalColumns: queryArg.additionalColumns,
          separatedAnalysisSummary: queryArg.separatedAnalysisSummary,
        },
      }),
    }),
    callAccessTokenControllerGetCallAccessToken: build.query<
      CallAccessTokenControllerGetCallAccessTokenApiResponse,
      CallAccessTokenControllerGetCallAccessTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/calls/${queryArg.id}/access-token`,
        params: { mode: queryArg.mode },
      }),
    }),
    callAccessTokenControllerGetExternalCallAccessToken: build.query<
      CallAccessTokenControllerGetExternalCallAccessTokenApiResponse,
      CallAccessTokenControllerGetExternalCallAccessTokenApiArg
    >({
      query: (queryArg) => ({ url: `/v2/external/calls/${queryArg.id}/access-token` }),
    }),
    callRecordingControllerGetCallRecording: build.query<
      CallRecordingControllerGetCallRecordingApiResponse,
      CallRecordingControllerGetCallRecordingApiArg
    >({
      query: (queryArg) => ({ url: `/v2/calls/${queryArg.id}/recording` }),
    }),
    campaignActiveCallPollControllerExternalCampaignActiveCallPoll: build.query<
      CampaignActiveCallPollControllerExternalCampaignActiveCallPollApiResponse,
      CampaignActiveCallPollControllerExternalCampaignActiveCallPollApiArg
    >({
      query: (queryArg) => ({ url: `/v2/external/campaigns/${queryArg.id}/poll-active-call` }),
    }),
    callNotAnalyzedListControllerSystemGetNotAnalyzedCalls: build.query<
      CallNotAnalyzedListControllerSystemGetNotAnalyzedCallsApiResponse,
      CallNotAnalyzedListControllerSystemGetNotAnalyzedCallsApiArg
    >({
      query: () => ({ url: `/v2/system/calls-not-analyzed` }),
    }),
    customerListPaginatedControllerGetCustomerListPaginated: build.query<
      CustomerListPaginatedControllerGetCustomerListPaginatedApiResponse,
      CustomerListPaginatedControllerGetCustomerListPaginatedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/customers/paginated`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          sortOrder: queryArg.sortOrder,
          campaignId: queryArg.campaignId,
          sortBy: queryArg.sortBy,
        },
      }),
    }),
    backgroundSoundAgentSettingsUpdateControllerExecute: build.mutation<
      BackgroundSoundAgentSettingsUpdateControllerExecuteApiResponse,
      BackgroundSoundAgentSettingsUpdateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agents/${queryArg.agentId}/background-sounds`,
        method: 'PATCH',
        body: queryArg.agentBackgroundSoundsRequestDto,
      }),
    }),
    backgroundSoundCreateControllerCreate: build.mutation<
      BackgroundSoundCreateControllerCreateApiResponse,
      BackgroundSoundCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/background-sounds`,
        method: 'POST',
        body: queryArg.backgroundSoundCreateRequestDto,
      }),
    }),
    backgroundSoundListControllerAdminList: build.query<
      BackgroundSoundListControllerAdminListApiResponse,
      BackgroundSoundListControllerAdminListApiArg
    >({
      query: () => ({ url: `/v2/admin/background-sounds` }),
    }),
    backgroundSoundDeleteControllerDelete: build.mutation<
      BackgroundSoundDeleteControllerDeleteApiResponse,
      BackgroundSoundDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/background-sounds/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    backgroundSoundUpdateControllerUpdate: build.mutation<
      BackgroundSoundUpdateControllerUpdateApiResponse,
      BackgroundSoundUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/background-sounds/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.backgroundSoundUpdateRequestDto,
      }),
    }),
    backgroundSoundUploadUrlControllerCreateUploadUrl: build.mutation<
      BackgroundSoundUploadUrlControllerCreateUploadUrlApiResponse,
      BackgroundSoundUploadUrlControllerCreateUploadUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/background-sounds/upload-url`,
        method: 'POST',
        body: queryArg.backgroundSoundUploadUrlRequestDto,
      }),
    }),
    backgroundSoundListControllerList: build.query<
      BackgroundSoundListControllerListApiResponse,
      BackgroundSoundListControllerListApiArg
    >({
      query: () => ({ url: `/v2/background-sounds` }),
    }),
    voiceListControllerVoiceList: build.query<
      VoiceListControllerVoiceListApiResponse,
      VoiceListControllerVoiceListApiArg
    >({
      query: () => ({ url: `/v2/voices` }),
    }),
    voiceListSystemControllerGetAllVoices: build.query<
      VoiceListSystemControllerGetAllVoicesApiResponse,
      VoiceListSystemControllerGetAllVoicesApiArg
    >({
      query: () => ({ url: `/v1/system/voices` }),
    }),
    voiceControllerGetVoice: build.query<
      VoiceControllerGetVoiceApiResponse,
      VoiceControllerGetVoiceApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/voices/${queryArg.id}` }),
    }),
    voiceDeleteControllerDeleteVoice: build.mutation<
      VoiceDeleteControllerDeleteVoiceApiResponse,
      VoiceDeleteControllerDeleteVoiceApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/voices/${queryArg.id}`, method: 'DELETE' }),
    }),
    voiceEditControllerEditVoice: build.mutation<
      VoiceEditControllerEditVoiceApiResponse,
      VoiceEditControllerEditVoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/voices/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.voiceRequestDto,
      }),
    }),
    voiceSystemControllerGetVoice: build.query<
      VoiceSystemControllerGetVoiceApiResponse,
      VoiceSystemControllerGetVoiceApiArg
    >({
      query: (queryArg) => ({ url: `/v1/system/voices/${queryArg.id}` }),
    }),
    voiceEditSystemControllerEditVoice: build.mutation<
      VoiceEditSystemControllerEditVoiceApiResponse,
      VoiceEditSystemControllerEditVoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/system/voices/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.voiceRequestDto,
      }),
    }),
    voiceCreateControllerCreateVoice: build.mutation<
      VoiceCreateControllerCreateVoiceApiResponse,
      VoiceCreateControllerCreateVoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/voices`,
        method: 'POST',
        body: queryArg.voiceRequestDto,
      }),
    }),
    voiceCreateSystemControllerCreateVoice: build.mutation<
      VoiceCreateSystemControllerCreateVoiceApiResponse,
      VoiceCreateSystemControllerCreateVoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/voice`,
        method: 'POST',
        body: queryArg.voiceRequestDto,
      }),
    }),
    voiceDeleteSystemControllerDeleteVoice: build.mutation<
      VoiceDeleteSystemControllerDeleteVoiceApiResponse,
      VoiceDeleteSystemControllerDeleteVoiceApiArg
    >({
      query: (queryArg) => ({ url: `/v1/system/voice/${queryArg.id}`, method: 'DELETE' }),
    }),
    transcriberListControllerTranscriberList: build.query<
      TranscriberListControllerTranscriberListApiResponse,
      TranscriberListControllerTranscriberListApiArg
    >({
      query: () => ({ url: `/v2/transcribers` }),
    }),
    transcriberListControllerGetTranscriber: build.query<
      TranscriberListControllerGetTranscriberApiResponse,
      TranscriberListControllerGetTranscriberApiArg
    >({
      query: (queryArg) => ({ url: `/v2/transcribers/${queryArg.id}` }),
    }),
    transcriberListControllerAdminTranscriberList: build.query<
      TranscriberListControllerAdminTranscriberListApiResponse,
      TranscriberListControllerAdminTranscriberListApiArg
    >({
      query: () => ({ url: `/v2/admin/transcribers` }),
    }),
    transcriberCreateControllerCreateTranscriber: build.mutation<
      TranscriberCreateControllerCreateTranscriberApiResponse,
      TranscriberCreateControllerCreateTranscriberApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/transcribers`,
        method: 'POST',
        body: queryArg.transcriberRequestDto,
      }),
    }),
    transcriberControllerGetTranscriber: build.query<
      TranscriberControllerGetTranscriberApiResponse,
      TranscriberControllerGetTranscriberApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/transcribers/${queryArg.id}` }),
    }),
    transcriberDeleteControllerDeleteTranscriber: build.mutation<
      TranscriberDeleteControllerDeleteTranscriberApiResponse,
      TranscriberDeleteControllerDeleteTranscriberApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/transcribers/${queryArg.id}`, method: 'DELETE' }),
    }),
    transcriberEditControllerEditTranscriber: build.mutation<
      TranscriberEditControllerEditTranscriberApiResponse,
      TranscriberEditControllerEditTranscriberApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/transcribers/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.transcriberRequestDto,
      }),
    }),
    createCompanyControllerCreateCompany: build.mutation<
      CreateCompanyControllerCreateCompanyApiResponse,
      CreateCompanyControllerCreateCompanyApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/companies`,
        method: 'POST',
        body: queryArg.createCompanyRequestDto,
      }),
    }),
    companyControllerGetCompany: build.query<
      CompanyControllerGetCompanyApiResponse,
      CompanyControllerGetCompanyApiArg
    >({
      query: (queryArg) => ({ url: `/v2/companies/${queryArg.id}` }),
    }),
    companyControllerGetCompanyAsAdmin: build.query<
      CompanyControllerGetCompanyAsAdminApiResponse,
      CompanyControllerGetCompanyAsAdminApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/companies/${queryArg.id}` }),
    }),
    editCompanyControllerEditCompany: build.mutation<
      EditCompanyControllerEditCompanyApiResponse,
      EditCompanyControllerEditCompanyApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/companies/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.editCompanyRequestDto,
      }),
    }),
    getAllCompanyIdsControllerGetAllCompanyIds: build.query<
      GetAllCompanyIdsControllerGetAllCompanyIdsApiResponse,
      GetAllCompanyIdsControllerGetAllCompanyIdsApiArg
    >({
      query: () => ({ url: `/v1/system/companies/only-ids` }),
    }),
    companyApiKeyCreateControllerApiKeyCreate: build.mutation<
      CompanyApiKeyCreateControllerApiKeyCreateApiResponse,
      CompanyApiKeyCreateControllerApiKeyCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/companies/${queryArg.id}/api-keys`,
        method: 'POST',
      }),
    }),
    companyApiKeyRevokeControllerApiKeyRevoke: build.mutation<
      CompanyApiKeyRevokeControllerApiKeyRevokeApiResponse,
      CompanyApiKeyRevokeControllerApiKeyRevokeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/companies/${queryArg.id}/api-keys/${queryArg.apiKeyId}`,
        method: 'DELETE',
      }),
    }),
    agentProfileCreateControllerAgentProfileCreateForUsers: build.mutation<
      AgentProfileCreateControllerAgentProfileCreateForUsersApiResponse,
      AgentProfileCreateControllerAgentProfileCreateForUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agent-profiles`,
        method: 'POST',
        body: queryArg.agentProfileCreateRequestDto,
      }),
    }),
    agentProfileListControllerAgentProfileListForUsers: build.query<
      AgentProfileListControllerAgentProfileListForUsersApiResponse,
      AgentProfileListControllerAgentProfileListForUsersApiArg
    >({
      query: (queryArg) => ({ url: `/v2/agent-profiles`, params: { filter: queryArg.filter } }),
    }),
    agentProfileCreateControllerAgentProfileCreateForManagers: build.mutation<
      AgentProfileCreateControllerAgentProfileCreateForManagersApiResponse,
      AgentProfileCreateControllerAgentProfileCreateForManagersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/agent-profiles`,
        method: 'POST',
        body: queryArg.agentProfileCreateAdminRequestDto,
      }),
    }),
    agentProfileListControllerAgentProfileListForAdmins: build.query<
      AgentProfileListControllerAgentProfileListForAdminsApiResponse,
      AgentProfileListControllerAgentProfileListForAdminsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/agent-profiles`,
        params: { filter: queryArg.filter },
      }),
    }),
    agentProfileEditControllerAgentProfileEditForUsers: build.mutation<
      AgentProfileEditControllerAgentProfileEditForUsersApiResponse,
      AgentProfileEditControllerAgentProfileEditForUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agent-profiles/${queryArg.profileId}`,
        method: 'PATCH',
        body: queryArg.agentProfileEditRequestDto,
      }),
    }),
    agentProfileDeleteControllerAgentProfileDeleteForUsers: build.mutation<
      AgentProfileDeleteControllerAgentProfileDeleteForUsersApiResponse,
      AgentProfileDeleteControllerAgentProfileDeleteForUsersApiArg
    >({
      query: (queryArg) => ({ url: `/v2/agent-profiles/${queryArg.profileId}`, method: 'DELETE' }),
    }),
    agentProfileEditControllerAgentProfileEditForManagers: build.mutation<
      AgentProfileEditControllerAgentProfileEditForManagersApiResponse,
      AgentProfileEditControllerAgentProfileEditForManagersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/agent-profiles/${queryArg.profileId}`,
        method: 'PATCH',
        body: queryArg.agentProfileEditRequestDto,
      }),
    }),
    agentProfileDeleteControllerAgentProfileDeleteForManagers: build.mutation<
      AgentProfileDeleteControllerAgentProfileDeleteForManagersApiResponse,
      AgentProfileDeleteControllerAgentProfileDeleteForManagersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/agent-profiles/${queryArg.profileId}`,
        method: 'DELETE',
      }),
    }),
    companyOverviewControllerGetCompanyOverview: build.query<
      CompanyOverviewControllerGetCompanyOverviewApiResponse,
      CompanyOverviewControllerGetCompanyOverviewApiArg
    >({
      query: () => ({ url: `/v2/company-overview` }),
    }),
    companyListControllerCompanyList: build.query<
      CompanyListControllerCompanyListApiResponse,
      CompanyListControllerCompanyListApiArg
    >({
      query: () => ({ url: `/v2/admin/companies` }),
    }),
    usageLimitControllerUsageLimits: build.query<
      UsageLimitControllerUsageLimitsApiResponse,
      UsageLimitControllerUsageLimitsApiArg
    >({
      query: () => ({ url: `/v2/usage-limits` }),
    }),
    usageLimitControllerAdminUsageLimits: build.query<
      UsageLimitControllerAdminUsageLimitsApiResponse,
      UsageLimitControllerAdminUsageLimitsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/companies/${queryArg.id}/usage-limits` }),
    }),
    usageLimitSetControllerSetLimits: build.mutation<
      UsageLimitSetControllerSetLimitsApiResponse,
      UsageLimitSetControllerSetLimitsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/usage-limits`,
        method: 'PATCH',
        body: queryArg.usageLimitSetRequestDto,
      }),
    }),
    usageLimitControllerSystemUsageLimits: build.query<
      UsageLimitControllerSystemUsageLimitsApiResponse,
      UsageLimitControllerSystemUsageLimitsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/system/companies/${queryArg.id}/usage-limits` }),
    }),
    companyVoicesSetControllerSetCompanyVoices: build.mutation<
      CompanyVoicesSetControllerSetCompanyVoicesApiResponse,
      CompanyVoicesSetControllerSetCompanyVoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/voices`,
        method: 'PUT',
        body: queryArg.companyVoicesSetRequestDto,
      }),
    }),
    companyTranscribersSetControllerSetCompanyTranscribers: build.mutation<
      CompanyTranscribersSetControllerSetCompanyTranscribersApiResponse,
      CompanyTranscribersSetControllerSetCompanyTranscribersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/transcribers`,
        method: 'PUT',
        body: queryArg.companyTranscribersSetRequestDto,
      }),
    }),
    companyLlmProvidersSetControllerSetCompanyLlmProviders: build.mutation<
      CompanyLlmProvidersSetControllerSetCompanyLlmProvidersApiResponse,
      CompanyLlmProvidersSetControllerSetCompanyLlmProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/llm-providers`,
        method: 'PUT',
        body: queryArg.companyLlmProvidersSetRequestDto,
      }),
    }),
    concurrentLimitSetControllerSetConcurrentLimit: build.mutation<
      ConcurrentLimitSetControllerSetConcurrentLimitApiResponse,
      ConcurrentLimitSetControllerSetConcurrentLimitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/concurrent-limit`,
        method: 'PATCH',
        body: queryArg.concurrentLimitSetRequestDto,
      }),
    }),
    unitWeightsControllerGetUnitWeights: build.query<
      UnitWeightsControllerGetUnitWeightsApiResponse,
      UnitWeightsControllerGetUnitWeightsApiArg
    >({
      query: () => ({ url: `/v2/admin/unit-weights` }),
    }),
    unitWeightsSetControllerSetUnitWeights: build.mutation<
      UnitWeightsSetControllerSetUnitWeightsApiResponse,
      UnitWeightsSetControllerSetUnitWeightsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/unit-weights`,
        method: 'PATCH',
        body: queryArg.unitWeightsSetRequestDto,
      }),
    }),
    livekitControllerWebhook: build.mutation<
      LivekitControllerWebhookApiResponse,
      LivekitControllerWebhookApiArg
    >({
      query: () => ({ url: `/v1/webhooks/livekit`, method: 'POST' }),
    }),
    campaignPostCallMessageCreateControllerCreate: build.mutation<
      CampaignPostCallMessageCreateControllerCreateApiResponse,
      CampaignPostCallMessageCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/post-call-messages`,
        method: 'POST',
        body: queryArg.campaignPostCallMessageCreateRequestDto,
      }),
    }),
    campaignPostCallMessagesControllerList: build.query<
      CampaignPostCallMessagesControllerListApiResponse,
      CampaignPostCallMessagesControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.campaignId}/post-call-messages` }),
    }),
    campaignPostCallMessageUpdateControllerUpdate: build.mutation<
      CampaignPostCallMessageUpdateControllerUpdateApiResponse,
      CampaignPostCallMessageUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/post-call-messages/${queryArg.messageId}`,
        method: 'PATCH',
        body: queryArg.campaignPostCallMessageUpdateRequestDto,
      }),
    }),
    campaignPostCallMessageDeleteControllerDelete: build.mutation<
      CampaignPostCallMessageDeleteControllerDeleteApiResponse,
      CampaignPostCallMessageDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/post-call-messages/${queryArg.messageId}`,
        method: 'DELETE',
      }),
    }),
    messageDeliverySweepControllerSystemDeliverySweep: build.mutation<
      MessageDeliverySweepControllerSystemDeliverySweepApiResponse,
      MessageDeliverySweepControllerSystemDeliverySweepApiArg
    >({
      query: () => ({ url: `/v2/system/messages/deliveries/sweep`, method: 'POST' }),
    }),
    messageDeliveryUpdateControllerWebhook: build.mutation<
      MessageDeliveryUpdateControllerWebhookApiResponse,
      MessageDeliveryUpdateControllerWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/webhooks/wassenger`,
        method: 'POST',
        params: { token: queryArg.token },
      }),
    }),
    fileCreateControllerCreate: build.mutation<
      FileCreateControllerCreateApiResponse,
      FileCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/files`,
        method: 'POST',
        body: queryArg.fileCreateRequestDto,
      }),
    }),
    fileListControllerList: build.query<
      FileListControllerListApiResponse,
      FileListControllerListApiArg
    >({
      query: () => ({ url: `/v2/files` }),
    }),
    fileDeleteControllerDelete: build.mutation<
      FileDeleteControllerDeleteApiResponse,
      FileDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/v2/files/${queryArg.id}`, method: 'DELETE' }),
    }),
    fileControllerGet: build.query<FileControllerGetApiResponse, FileControllerGetApiArg>({
      query: (queryArg) => ({ url: `/v2/files/${queryArg.id}` }),
    }),
    squadCreateControllerExecute: build.mutation<
      SquadCreateControllerExecuteApiResponse,
      SquadCreateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/squads`,
        method: 'POST',
        body: queryArg.squadCreateRequestDto,
      }),
    }),
    squadDeleteControllerExecute: build.mutation<
      SquadDeleteControllerExecuteApiResponse,
      SquadDeleteControllerExecuteApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/squads`, method: 'DELETE' }),
    }),
    squadAgentCreateControllerExecute: build.mutation<
      SquadAgentCreateControllerExecuteApiResponse,
      SquadAgentCreateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/squads/${queryArg.id}/agents`,
        method: 'POST',
        body: queryArg.agentRequestDto,
      }),
    }),
    squadAgentUpdateControllerExecute: build.mutation<
      SquadAgentUpdateControllerExecuteApiResponse,
      SquadAgentUpdateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/squads/${queryArg.id}/agents/${queryArg.agentId}`,
        method: 'PUT',
        body: queryArg.squadAgentUpdateRequestDto,
      }),
    }),
    squadAgentDeleteControllerExecute: build.mutation<
      SquadAgentDeleteControllerExecuteApiResponse,
      SquadAgentDeleteControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/squads/${queryArg.id}/agents/${queryArg.agentId}`,
        method: 'DELETE',
      }),
    }),
    handoffRuleCreateControllerExecute: build.mutation<
      HandoffRuleCreateControllerExecuteApiResponse,
      HandoffRuleCreateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/squads/${queryArg.id}/handoff-rules`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    structuredOutputCreateControllerCreate: build.mutation<
      StructuredOutputCreateControllerCreateApiResponse,
      StructuredOutputCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structured-outputs`,
        method: 'POST',
        body: queryArg.structuredOutputCreateRequestDto,
      }),
    }),
    structuredOutputListControllerList: build.query<
      StructuredOutputListControllerListApiResponse,
      StructuredOutputListControllerListApiArg
    >({
      query: () => ({ url: `/v2/structured-outputs` }),
    }),
    structuredOutputUpdateControllerUpdate: build.mutation<
      StructuredOutputUpdateControllerUpdateApiResponse,
      StructuredOutputUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structured-outputs/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.structuredOutputUpdateRequestDto,
      }),
    }),
    structuredOutputDeleteControllerDelete: build.mutation<
      StructuredOutputDeleteControllerDeleteApiResponse,
      StructuredOutputDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/v2/structured-outputs/${queryArg.id}`, method: 'DELETE' }),
    }),
    structuredOutputControllerGet: build.query<
      StructuredOutputControllerGetApiResponse,
      StructuredOutputControllerGetApiArg
    >({
      query: (queryArg) => ({ url: `/v2/structured-outputs/${queryArg.id}` }),
    }),
    structuredOutputTemplateListControllerList: build.query<
      StructuredOutputTemplateListControllerListApiResponse,
      StructuredOutputTemplateListControllerListApiArg
    >({
      query: () => ({ url: `/v2/structured-output-templates` }),
    }),
    structuredOutputTemplateControllerGet: build.query<
      StructuredOutputTemplateControllerGetApiResponse,
      StructuredOutputTemplateControllerGetApiArg
    >({
      query: (queryArg) => ({ url: `/v2/structured-output-templates/${queryArg.id}` }),
    }),
    campaignStructuredOutputAttachControllerAttach: build.mutation<
      CampaignStructuredOutputAttachControllerAttachApiResponse,
      CampaignStructuredOutputAttachControllerAttachApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/structured-outputs`,
        method: 'POST',
        body: queryArg.campaignStructuredOutputAttachRequestDto,
      }),
    }),
    campaignStructuredOutputListControllerList: build.query<
      CampaignStructuredOutputListControllerListApiResponse,
      CampaignStructuredOutputListControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/structured-outputs` }),
    }),
    campaignStructuredOutputDetachControllerDetach: build.mutation<
      CampaignStructuredOutputDetachControllerDetachApiResponse,
      CampaignStructuredOutputDetachControllerDetachApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/structured-outputs/${queryArg.outputId}`,
        method: 'DELETE',
      }),
    }),
    toolCreateControllerCreateCampaignTool: build.mutation<
      ToolCreateControllerCreateCampaignToolApiResponse,
      ToolCreateControllerCreateCampaignToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/tools`,
        method: 'POST',
        body: queryArg.toolRequestDto,
      }),
    }),
    toolListControllerCampaignToolList: build.query<
      ToolListControllerCampaignToolListApiResponse,
      ToolListControllerCampaignToolListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/tools` }),
    }),
    toolCreateControllerCreateAgentTool: build.mutation<
      ToolCreateControllerCreateAgentToolApiResponse,
      ToolCreateControllerCreateAgentToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agents/${queryArg.id}/tools`,
        method: 'POST',
        body: queryArg.toolRequestDto,
      }),
    }),
    toolListControllerAgentTollList: build.query<
      ToolListControllerAgentTollListApiResponse,
      ToolListControllerAgentTollListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/agents/${queryArg.id}/tools` }),
    }),
    toolUpdateControllerCreateCampaignTool: build.mutation<
      ToolUpdateControllerCreateCampaignToolApiResponse,
      ToolUpdateControllerCreateCampaignToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/tools/${queryArg.toolId}`,
        method: 'PUT',
        body: queryArg.toolUpdateRequestDto,
      }),
    }),
    toolDeleteControllerCreateCampaignTool: build.mutation<
      ToolDeleteControllerCreateCampaignToolApiResponse,
      ToolDeleteControllerCreateCampaignToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/tools/${queryArg.toolId}`,
        method: 'DELETE',
      }),
    }),
    toolUpdateControllerCreateAgentTool: build.mutation<
      ToolUpdateControllerCreateAgentToolApiResponse,
      ToolUpdateControllerCreateAgentToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agents/${queryArg.id}/tools/${queryArg.toolId}`,
        method: 'PUT',
        body: queryArg.toolUpdateRequestDto,
      }),
    }),
    toolDeleteControllerCreateAgentTool: build.mutation<
      ToolDeleteControllerCreateAgentToolApiResponse,
      ToolDeleteControllerCreateAgentToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agents/${queryArg.id}/tools/${queryArg.toolId}`,
        method: 'DELETE',
      }),
    }),
    llmProviderListControllerProviderList: build.query<
      LlmProviderListControllerProviderListApiResponse,
      LlmProviderListControllerProviderListApiArg
    >({
      query: () => ({ url: `/v2/llm-providers` }),
    }),
    llmProviderListControllerAdminProviderList: build.query<
      LlmProviderListControllerAdminProviderListApiResponse,
      LlmProviderListControllerAdminProviderListApiArg
    >({
      query: () => ({ url: `/v2/admin/llm-providers` }),
    }),
    llmModelListControllerModelList: build.query<
      LlmModelListControllerModelListApiResponse,
      LlmModelListControllerModelListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/llm-providers/${queryArg.id}/models` }),
    }),
    llmModelListControllerAdminModelList: build.query<
      LlmModelListControllerAdminModelListApiResponse,
      LlmModelListControllerAdminModelListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/llm-providers/${queryArg.id}/models` }),
    }),
    campaignWebhookCreateControllerCreate: build.mutation<
      CampaignWebhookCreateControllerCreateApiResponse,
      CampaignWebhookCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/webhooks`,
        method: 'POST',
        body: queryArg.campaignWebhookCreateRequestDto,
      }),
    }),
    campaignWebhooksControllerList: build.query<
      CampaignWebhooksControllerListApiResponse,
      CampaignWebhooksControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.campaignId}/webhooks` }),
    }),
    campaignWebhookUpdateControllerUpdate: build.mutation<
      CampaignWebhookUpdateControllerUpdateApiResponse,
      CampaignWebhookUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/webhooks/${queryArg.webhookId}`,
        method: 'PATCH',
        body: queryArg.campaignWebhookUpdateRequestDto,
      }),
    }),
    campaignWebhookDeleteControllerDelete: build.mutation<
      CampaignWebhookDeleteControllerDeleteApiResponse,
      CampaignWebhookDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/webhooks/${queryArg.webhookId}`,
        method: 'DELETE',
      }),
    }),
    campaignWebhookDispatchControllerManualDispatch: build.mutation<
      CampaignWebhookDispatchControllerManualDispatchApiResponse,
      CampaignWebhookDispatchControllerManualDispatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/calls/${queryArg.callId}/webhooks/dispatch`,
        method: 'POST',
      }),
    }),
    campaignWebhookDispatchControllerSystemDispatch: build.mutation<
      CampaignWebhookDispatchControllerSystemDispatchApiResponse,
      CampaignWebhookDispatchControllerSystemDispatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.campaignId}/calls/${queryArg.callId}/webhooks/dispatch`,
        method: 'POST',
      }),
    }),
    webhookDeliverySweepControllerSystemDeliverySweep: build.mutation<
      WebhookDeliverySweepControllerSystemDeliverySweepApiResponse,
      WebhookDeliverySweepControllerSystemDeliverySweepApiArg
    >({
      query: () => ({ url: `/v2/system/webhooks/deliveries/sweep`, method: 'POST' }),
    }),
    healthControllerCheck: build.query<
      HealthControllerCheckApiResponse,
      HealthControllerCheckApiArg
    >({
      query: () => ({ url: `/health` }),
    }),
    usageMonitoringControllerGetUsage: build.query<
      UsageMonitoringControllerGetUsageApiResponse,
      UsageMonitoringControllerGetUsageApiArg
    >({
      query: () => ({ url: `/v2/admin/usage-models` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as apiService };
export type AppControllerGetHelloApiResponse = /** status 200  */ string;
export type AppControllerGetHelloApiArg = void;
export type MetricsControllerWebhookApiResponse = unknown;
export type MetricsControllerWebhookApiArg = void;
export type RefreshTokensControllerRefreshTokenUserApiResponse =
  /** status 201  */ AccessTokenResponseDto;
export type RefreshTokensControllerRefreshTokenUserApiArg = void;
export type RefreshTokensControllerRefreshTokenAdminApiResponse =
  /** status 201  */ AccessTokenResponseDto;
export type RefreshTokensControllerRefreshTokenAdminApiArg = void;
export type SignInControllerSignInUserApiResponse = /** status 201  */ AccessTokenResponseDto;
export type SignInControllerSignInUserApiArg = {
  signInRequestDto: SignInRequestDto;
};
export type SignInControllerSignInAdminApiResponse = /** status 201  */ AccessTokenResponseDto;
export type SignInControllerSignInAdminApiArg = {
  signInRequestDto: SignInRequestDto;
};
export type ApiKeyControllerGetSystemApiKeyInfoApiResponse = /** status 200  */ ApiKeyDto;
export type ApiKeyControllerGetSystemApiKeyInfoApiArg = {
  jti: string;
};
export type ForgotPasswordControllerForgotPasswordApiResponse =
  /** status 201  */ ForgotPasswordResponseDto;
export type ForgotPasswordControllerForgotPasswordApiArg = {
  forgotPasswordRequestDto: ForgotPasswordRequestDto;
};
export type ResetPasswordControllerResetPasswordApiResponse =
  /** status 201  */ ResetPasswordResponseDto;
export type ResetPasswordControllerResetPasswordApiArg = {
  resetPasswordRequestDto: ResetPasswordRequestDto;
};
export type UserMeControllerUserMeApiResponse = /** status 200  */ UserDto;
export type UserMeControllerUserMeApiArg = void;
export type GetUsersListControllerGetUsersListApiResponse = /** status 200  */ UserDto[];
export type GetUsersListControllerGetUsersListApiArg = {
  id: string;
};
export type EditUserControllerEditUserApiResponse = /** status 200  */ UserDto;
export type EditUserControllerEditUserApiArg = {
  id: string;
  editUserRequestDto: EditUserRequestDto;
};
export type UserCreateControllerCreateUserApiResponse = /** status 201  */ UserDto;
export type UserCreateControllerCreateUserApiArg = {
  userCreateRequestDto: UserCreateRequestDto;
};
export type AdminMeControllerAdminMeApiResponse = /** status 200  */ AdminDto;
export type AdminMeControllerAdminMeApiArg = void;
export type AnalysisStaleSweepControllerSystemAnalysisStaleSweepApiResponse =
  /** status 201  */ object;
export type AnalysisStaleSweepControllerSystemAnalysisStaleSweepApiArg = void;
export type CallAnalysisCreateControllerSystemCreateCallAnalysisApiResponse =
  /** status 201  */ Analysis;
export type CallAnalysisCreateControllerSystemCreateCallAnalysisApiArg = {
  id: string;
  /** Accepts legacy completed payloads without status and explicit completed/failed callbacks from the analysis service. */
  callAnalysisCreateRequestDto: CallAnalysisCreateRequestDto;
};
export type CallSentimentCreateControllerCreateCallSentimentApiResponse =
  /** status 201  */ SentimentDto;
export type CallSentimentCreateControllerCreateCallSentimentApiArg = {
  id: string;
  sentimentRequestDto: SentimentRequestDto;
};
export type CallUpdateControllerSystemCallUpdateApiResponse = /** status 200  */ CallDto;
export type CallUpdateControllerSystemCallUpdateApiArg = {
  id: string;
  callRequestDto: CallRequestDto;
};
export type CallControllerSystemGetCallByIdApiResponse = /** status 200  */ CallDto;
export type CallControllerSystemGetCallByIdApiArg = {
  id: string;
  relations?:
    | 'customer'
    | 'customer.campaign'
    | 'agent'
    | 'company'
    | 'analysis'
    | 'agent.profile'
    | 'agent.voice'
    | 'agent.transcriber'
    | 'agent.analysisPlan'
    | 'agent.toolSettings'
    | 'agent.toolSettings.tool'
    | 'squad'
    | 'squad.handoffRules'
    | 'squad.agents'
    | 'squad.agents.agent'
    | 'squad.agents.agent.profile'
    | 'squad.agents.agent.voice'
    | 'squad.agents.agent.transcriber'
    | 'squad.agents.agent.analysisPlan'
    | 'squad.agents.agent.toolSettings'
    | 'squad.agents.agent.toolSettings.tool';
};
export type CallSupervisorModeControllerSetSupervisorModeApiResponse =
  /** status 200  */ CallSupervisorModeDto;
export type CallSupervisorModeControllerSetSupervisorModeApiArg = {
  id: string;
  callSupervisorModeRequestDto: CallSupervisorModeRequestDto;
};
export type CallStaleSweepControllerSystemStaleSweepApiResponse = /** status 201  */ object;
export type CallStaleSweepControllerSystemStaleSweepApiArg = void;
export type CampaignTestCallCreateControllerTestCallCreateApiResponse =
  /** status 201  */ CampaignTestCallCreateResponseDto;
export type CampaignTestCallCreateControllerTestCallCreateApiArg = {
  id: string;
  campaignTestCallCreateRequestDto: CampaignTestCallCreateRequestDto;
};
export type CampaignCallListControllerCallListApiResponse = /** status 200  */ CallDto[];
export type CampaignCallListControllerCallListApiArg = {
  id: string;
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  sortBy?: 'phoneNumber' | 'createdAt' | 'startDate' | 'endedAt' | 'callDuration' | 'sentiments';
  sortOrder?: 'ASC' | 'DESC';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
};
export type CampaignTestCallCreateControllerExternalTestCallCreateApiResponse =
  /** status 201  */ CampaignTestCallCreateResponseDto;
export type CampaignTestCallCreateControllerExternalTestCallCreateApiArg = {
  id: string;
  campaignTestCallCreateRequestDto: CampaignTestCallCreateRequestDto;
};
export type CallCreateExternalControllerCampaignOutboundCallApiResponse =
  /** status 201  */ CustomerDto[];
export type CallCreateExternalControllerCampaignOutboundCallApiArg = {
  id: string;
  callCreateExternalRequestDto: CallCreateExternalRequestDto;
};
export type CampaignCallHangupControllerCampaignCallHangupApiResponse = /** status 201  */ CallDto;
export type CampaignCallHangupControllerCampaignCallHangupApiArg = {
  id: string;
  callId: string;
};
export type CampaignCallHangupControllerExternalCampaignCallHangupApiResponse =
  /** status 201  */ CallDto;
export type CampaignCallHangupControllerExternalCampaignCallHangupApiArg = {
  id: string;
  callId: string;
};
export type CampaignCloneSystemControllerCloneCampaignApiResponse = unknown;
export type CampaignCloneSystemControllerCloneCampaignApiArg = {
  campaignId: string;
  campaignCloneRequestDto: CampaignCloneRequestDto;
};
export type CampaignCreateControllerCampaignCreateApiResponse = /** status 201  */ CampaignDto;
export type CampaignCreateControllerCampaignCreateApiArg = {
  campaignCreateRequestDto: CampaignCreateRequestDto;
};
export type CampaignListControllerCampaignListApiResponse = /** status 200  */ CampaignDto[];
export type CampaignListControllerCampaignListApiArg = void;
export type CampaignDeleteControllerDeleteCampaignApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CampaignDeleteControllerDeleteCampaignApiArg = {
  id: string;
};
export type CampaignUpdateControllerCampaignUpdateApiResponse = /** status 200  */ CampaignDto;
export type CampaignUpdateControllerCampaignUpdateApiArg = {
  id: string;
  campaignUpdateRequestDto: CampaignUpdateRequestDto;
};
export type CampaignControllerCampaignApiResponse = /** status 200  */ CampaignDto;
export type CampaignControllerCampaignApiArg = {
  id: string;
};
export type CampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerApiResponse =
  /** status 201  */ object[];
export type CampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerApiArg = void;
export type CampaignAnalysisBatchRunControllerSystemRunAnalysisBatchApiResponse =
  /** status 200  */ CampaignAnalysisBatchRunResponseDto;
export type CampaignAnalysisBatchRunControllerSystemRunAnalysisBatchApiArg = {
  id: string;
};
export type CampaignStructuredOutputGenerateControllerGenerateApiResponse =
  /** status 200  */ CampaignStructuredOutputGenerateResponseDto;
export type CampaignStructuredOutputGenerateControllerGenerateApiArg = {
  id: string;
};
export type CampaignOutboundCallsProcessControllerSystemOutboundCallsProcessApiResponse =
  /** status 201  */ string[];
export type CampaignOutboundCallsProcessControllerSystemOutboundCallsProcessApiArg = void;
export type CampaignCompletionSweepControllerSystemCompletionSweepApiResponse =
  /** status 201  */ string[];
export type CampaignCompletionSweepControllerSystemCompletionSweepApiArg = void;
export type CampaignRunControllerCampaignRunApiResponse = /** status 201  */ CampaignDto;
export type CampaignRunControllerCampaignRunApiArg = {
  id: string;
};
export type CampaignSipTrunkCreateControllerCampaignCreateApiResponse =
  /** status 201  */ SipTrunkDto;
export type CampaignSipTrunkCreateControllerCampaignCreateApiArg = {
  id: string;
  campaignSipTrunkCreateRequestDto: CampaignSipTrunkCreateRequestDto;
};
export type CampaignSipTrunkControllerGetSipTrunkApiResponse =
  /** status 200  */ SipTrunkResponseDto;
export type CampaignSipTrunkControllerGetSipTrunkApiArg = {
  id: string;
};
export type CampaignStopControllerCampaignStopApiResponse = /** status 201  */ CampaignDto;
export type CampaignStopControllerCampaignStopApiArg = {
  id: string;
};
export type CampaignsStopExceededLimitsControllerStopExceededLimitsApiResponse =
  /** status 201  */ CampaignsStopExceededLimitsResponseDto;
export type CampaignsStopExceededLimitsControllerStopExceededLimitsApiArg = void;
export type CustomerUpdateControllerUpdateCustomerApiResponse = /** status 200  */ CustomerDto;
export type CustomerUpdateControllerUpdateCustomerApiArg = {
  customerId: string;
  customerUpdateRequestDto: CustomerUpdateRequestDto;
};
export type CampaignAgentCreateControllerExecuteApiResponse = /** status 201  */ AgentDto;
export type CampaignAgentCreateControllerExecuteApiArg = {
  id: string;
  agentRequestDto: AgentRequestDto;
};
export type CampaignAgentListControllerListApiResponse = /** status 200  */ AgentDto[];
export type CampaignAgentListControllerListApiArg = {
  id: string;
};
export type CampaignAgentUpdateControllerExecuteApiResponse = /** status 200  */ AgentDto;
export type CampaignAgentUpdateControllerExecuteApiArg = {
  id: string;
  agentId: string;
  agentRequestDto: AgentRequestDto;
};
export type CampaignAgentDeleteControllerExecuteApiResponse = /** status 200  */ BaseOkResponseDto;
export type CampaignAgentDeleteControllerExecuteApiArg = {
  id: string;
  agentId: string;
};
export type CallActionCreateControllerSystemCallActionCreateApiResponse =
  /** status 201  */ CallActionDto;
export type CallActionCreateControllerSystemCallActionCreateApiArg = {
  id: string;
  callActionRequestDto: CallActionRequestDto;
};
export type CallCreateSystemControllerSystemCampaignCallCreateApiResponse =
  /** status 201  */ CallDto;
export type CallCreateSystemControllerSystemCampaignCallCreateApiArg = {
  id: string;
  callCreateSystemRequestDto: CallCreateSystemRequestDto;
};
export type CallControllerGetCallByIdApiResponse = /** status 200  */ CallDto;
export type CallControllerGetCallByIdApiArg = {
  id: string;
  relations?:
    | 'customer'
    | 'customer.campaign'
    | 'agent'
    | 'company'
    | 'analysis'
    | 'agent.profile'
    | 'agent.voice'
    | 'agent.transcriber'
    | 'agent.analysisPlan'
    | 'agent.toolSettings'
    | 'agent.toolSettings.tool'
    | 'squad'
    | 'squad.handoffRules'
    | 'squad.agents'
    | 'squad.agents.agent'
    | 'squad.agents.agent.profile'
    | 'squad.agents.agent.voice'
    | 'squad.agents.agent.transcriber'
    | 'squad.agents.agent.analysisPlan'
    | 'squad.agents.agent.toolSettings'
    | 'squad.agents.agent.toolSettings.tool';
};
export type CampaignControllerSystemCampaignApiResponse = /** status 200  */ SystemCampaignDto;
export type CampaignControllerSystemCampaignApiArg = {
  id: string;
  relations?:
    | 'ambientSoundSetting'
    | 'ambientSoundSetting.sound'
    | 'thinkingSoundSettings'
    | 'thinkingSoundSettings.sound'
    | 'campaignAgents'
    | 'campaignAgents.agent'
    | 'campaignAgents.agent.idleState'
    | 'campaignAgents.agent.llmModel'
    | 'campaignAgents.agent.llmProvider'
    | 'campaignAgents.agent.profile'
    | 'campaignAgents.agent.voice'
    | 'campaignAgents.agent.transcriber'
    | 'campaignAgents.agent.toolSettings'
    | 'campaignAgents.agent.toolSettings.tool'
    | 'campaignAgents.agent.ambientSoundSetting'
    | 'campaignAgents.agent.ambientSoundSetting.sound'
    | 'campaignAgents.agent.thinkingSoundSettings'
    | 'campaignAgents.agent.thinkingSoundSettings.sound'
    | 'callSchedule'
    | 'sipTrunks'
    | 'analysisPlan'
    | 'campaignStructuredOutputs.structuredOutput'
    | 'toolSettings.tool'
    | 'files'
    | 'customers'
    | 'squad'
    | 'squad.handoffRules'
    | 'squad.agents'
    | 'squad.agents.agent'
    | 'squad.agents.agent.idleState'
    | 'squad.agents.agent.llmModel'
    | 'squad.agents.agent.llmProvider'
    | 'squad.agents.agent.profile'
    | 'squad.agents.agent.voice'
    | 'squad.agents.agent.transcriber'
    | 'squad.agents.agent.analysisPlan'
    | 'squad.agents.agent.toolSettings'
    | 'squad.agents.agent.toolSettings.tool'
    | 'squad.agents.agent.ambientSoundSetting'
    | 'squad.agents.agent.ambientSoundSetting.sound'
    | 'squad.agents.agent.thinkingSoundSettings'
    | 'squad.agents.agent.thinkingSoundSettings.sound';
};
export type CampaignCallControllerCallApiResponse = /** status 200  */ CallDto;
export type CampaignCallControllerCallApiArg = {
  id: string;
  callId: string;
};
export type CampaignCallListPaginatedControllerCallListPaginatedApiResponse =
  /** status 200  */ CampaignCallListPaginatedDto;
export type CampaignCallListPaginatedControllerCallListPaginatedApiArg = {
  id: string;
  limit?: number;
  cursor?: string;
  sortOrder?: 'ASC' | 'DESC';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  sortBy?: 'phoneNumber' | 'createdAt' | 'startDate' | 'endedAt' | 'callDuration' | 'sentiments';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  /** Include total calls count in response meta */
  withTotal?: boolean;
};
export type CampaignFileListControllerListApiResponse = /** status 200  */ FileResponseDto[];
export type CampaignFileListControllerListApiArg = {
  id: string;
};
export type CampaignListControllerExternalCampaignListApiResponse =
  /** status 200  */ ExternalCampaignDto[];
export type CampaignListControllerExternalCampaignListApiArg = void;
export type CampaignListPaginatedControllerGetCampaignListPaginatedApiResponse =
  /** status 200  */ CampaignListPaginatedDto;
export type CampaignListPaginatedControllerGetCampaignListPaginatedApiArg = {
  limit?: number;
  cursor?: string;
  sortOrder?: 'ASC' | 'DESC';
  sortBy?: 'title' | 'createdAt';
  /** Include total campaigns count in response meta */
  withTotal?: boolean;
  /** Filter campaigns by title (case-insensitive substring) */
  search?: string;
};
export type CampaignMetricCallDurationControllerCalculateCallDurationIqrApiResponse =
  /** status 200  */ CampaignMetricCallDurationResponseDto;
export type CampaignMetricCallDurationControllerCalculateCallDurationIqrApiArg = {
  id: string;
};
export type CampaignReportControllerUserCampaignsReportApiResponse = unknown;
export type CampaignReportControllerUserCampaignsReportApiArg = {
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  /** CSV of optional columns. Mandatory columns are always included: phoneNumber,startDate,endDate,status,endReason. */
  additionalColumns?:
    | 'callId'
    | 'callDuration'
    | 'retries'
    | 'whatsappFollowUp'
    | 'whatsappDelivered'
    | 'generateWhatsappMessage'
    | 'generatedWhatsappMessageDelivered'
    | 'agentNameAndAccent'
    | 'sentiments'
    | 'analysisSummary'
    | 'analysisDetailedSummary'
    | 'parentCallId'
    | 'campaignName'
    | 'campaignId'
    | 'recordingUrl'
    | 'transcriptUrl';
  separatedAnalysisSummary?: boolean;
};
export type CampaignReportControllerUserCampaignReportApiResponse = unknown;
export type CampaignReportControllerUserCampaignReportApiArg = {
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  /** CSV of optional columns. Mandatory columns are always included: phoneNumber,startDate,endDate,status,endReason. */
  additionalColumns?:
    | 'callId'
    | 'callDuration'
    | 'retries'
    | 'whatsappFollowUp'
    | 'whatsappDelivered'
    | 'generateWhatsappMessage'
    | 'generatedWhatsappMessageDelivered'
    | 'agentNameAndAccent'
    | 'sentiments'
    | 'analysisSummary'
    | 'analysisDetailedSummary'
    | 'parentCallId'
    | 'campaignName'
    | 'campaignId'
    | 'recordingUrl'
    | 'transcriptUrl';
  separatedAnalysisSummary?: boolean;
  id: string;
};
export type CampaignReportControllerAdminCampaignsReportApiResponse = unknown;
export type CampaignReportControllerAdminCampaignsReportApiArg = {
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  /** CSV of optional columns. Mandatory columns are always included: phoneNumber,startDate,endDate,status,endReason. */
  additionalColumns?:
    | 'callId'
    | 'callDuration'
    | 'retries'
    | 'whatsappFollowUp'
    | 'whatsappDelivered'
    | 'generateWhatsappMessage'
    | 'generatedWhatsappMessageDelivered'
    | 'agentNameAndAccent'
    | 'sentiments'
    | 'analysisSummary'
    | 'analysisDetailedSummary'
    | 'parentCallId'
    | 'campaignName'
    | 'campaignId'
    | 'recordingUrl'
    | 'transcriptUrl';
  separatedAnalysisSummary?: boolean;
};
export type CampaignReportControllerAdminCampaignReportApiResponse = unknown;
export type CampaignReportControllerAdminCampaignReportApiArg = {
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  /** CSV of optional columns. Mandatory columns are always included: phoneNumber,startDate,endDate,status,endReason. */
  additionalColumns?:
    | 'callId'
    | 'callDuration'
    | 'retries'
    | 'whatsappFollowUp'
    | 'whatsappDelivered'
    | 'generateWhatsappMessage'
    | 'generatedWhatsappMessageDelivered'
    | 'agentNameAndAccent'
    | 'sentiments'
    | 'analysisSummary'
    | 'analysisDetailedSummary'
    | 'parentCallId'
    | 'campaignName'
    | 'campaignId'
    | 'recordingUrl'
    | 'transcriptUrl';
  separatedAnalysisSummary?: boolean;
  id: string;
};
export type CallAccessTokenControllerGetCallAccessTokenApiResponse =
  /** status 200  */ CallAccessTokenDto;
export type CallAccessTokenControllerGetCallAccessTokenApiArg = {
  id: string;
  /** Omit for the passive viewer token (Admin and Viewer). Supplying it opens a supervisor session and requires the Admin role. */
  mode?: 'listen' | 'barge';
};
export type CallAccessTokenControllerGetExternalCallAccessTokenApiResponse =
  /** status 200  */ CallAccessTokenDto;
export type CallAccessTokenControllerGetExternalCallAccessTokenApiArg = {
  id: string;
};
export type CallRecordingControllerGetCallRecordingApiResponse =
  /** status 200  */ CallRecordingDto;
export type CallRecordingControllerGetCallRecordingApiArg = {
  id: string;
};
export type CampaignActiveCallPollControllerExternalCampaignActiveCallPollApiResponse =
  /** status 200  */ object;
export type CampaignActiveCallPollControllerExternalCampaignActiveCallPollApiArg = {
  id: string;
};
export type CallNotAnalyzedListControllerSystemGetNotAnalyzedCallsApiResponse =
  /** status 200  */ CallNotAnalyzedListDto[];
export type CallNotAnalyzedListControllerSystemGetNotAnalyzedCallsApiArg = void;
export type CustomerListPaginatedControllerGetCustomerListPaginatedApiResponse =
  /** status 200  */ CustomerListPaginatedDto;
export type CustomerListPaginatedControllerGetCustomerListPaginatedApiArg = {
  limit?: number;
  cursor?: string;
  sortOrder?: 'ASC' | 'DESC';
  campaignId: string;
  sortBy?: 'name' | 'createdAt';
};
export type BackgroundSoundAgentSettingsUpdateControllerExecuteApiResponse =
  /** status 200  */ AgentBackgroundSoundsResponseDto;
export type BackgroundSoundAgentSettingsUpdateControllerExecuteApiArg = {
  agentId: string;
  agentBackgroundSoundsRequestDto: AgentBackgroundSoundsRequestDto;
};
export type BackgroundSoundCreateControllerCreateApiResponse =
  /** status 201  */ BackgroundSoundResponseDto;
export type BackgroundSoundCreateControllerCreateApiArg = {
  backgroundSoundCreateRequestDto: BackgroundSoundCreateRequestDto;
};
export type BackgroundSoundListControllerAdminListApiResponse =
  /** status 200  */ BackgroundSoundResponseDto[];
export type BackgroundSoundListControllerAdminListApiArg = void;
export type BackgroundSoundDeleteControllerDeleteApiResponse = /** status 200  */ BaseOkResponseDto;
export type BackgroundSoundDeleteControllerDeleteApiArg = {
  id: string;
};
export type BackgroundSoundUpdateControllerUpdateApiResponse =
  /** status 200  */ BackgroundSoundResponseDto;
export type BackgroundSoundUpdateControllerUpdateApiArg = {
  id: string;
  backgroundSoundUpdateRequestDto: BackgroundSoundUpdateRequestDto;
};
export type BackgroundSoundUploadUrlControllerCreateUploadUrlApiResponse =
  /** status 201  */ BackgroundSoundUploadUrlResponseDto;
export type BackgroundSoundUploadUrlControllerCreateUploadUrlApiArg = {
  backgroundSoundUploadUrlRequestDto: BackgroundSoundUploadUrlRequestDto;
};
export type BackgroundSoundListControllerListApiResponse =
  /** status 200  */ BackgroundSoundResponseDto[];
export type BackgroundSoundListControllerListApiArg = void;
export type VoiceListControllerVoiceListApiResponse = /** status 200  */ VoiceDto[];
export type VoiceListControllerVoiceListApiArg = void;
export type VoiceListSystemControllerGetAllVoicesApiResponse = unknown;
export type VoiceListSystemControllerGetAllVoicesApiArg = void;
export type VoiceControllerGetVoiceApiResponse = /** status 200  */ VoiceDto;
export type VoiceControllerGetVoiceApiArg = {
  id: string;
};
export type VoiceDeleteControllerDeleteVoiceApiResponse = /** status 200  */ BaseOkResponseDto;
export type VoiceDeleteControllerDeleteVoiceApiArg = {
  id: string;
};
export type VoiceEditControllerEditVoiceApiResponse = /** status 200  */ VoiceDto;
export type VoiceEditControllerEditVoiceApiArg = {
  id: string;
  voiceRequestDto: VoiceRequestDto;
};
export type VoiceSystemControllerGetVoiceApiResponse = unknown;
export type VoiceSystemControllerGetVoiceApiArg = {
  id: string;
};
export type VoiceEditSystemControllerEditVoiceApiResponse = unknown;
export type VoiceEditSystemControllerEditVoiceApiArg = {
  id: string;
  voiceRequestDto: VoiceRequestDto;
};
export type VoiceCreateControllerCreateVoiceApiResponse = /** status 201  */ VoiceDto;
export type VoiceCreateControllerCreateVoiceApiArg = {
  voiceRequestDto: VoiceRequestDto;
};
export type VoiceCreateSystemControllerCreateVoiceApiResponse = unknown;
export type VoiceCreateSystemControllerCreateVoiceApiArg = {
  voiceRequestDto: VoiceRequestDto;
};
export type VoiceDeleteSystemControllerDeleteVoiceApiResponse = unknown;
export type VoiceDeleteSystemControllerDeleteVoiceApiArg = {
  id: string;
};
export type TranscriberListControllerTranscriberListApiResponse =
  /** status 200  */ TranscriberResponseDto[];
export type TranscriberListControllerTranscriberListApiArg = void;
export type TranscriberListControllerGetTranscriberApiResponse =
  /** status 200  */ TranscriberResponseDto;
export type TranscriberListControllerGetTranscriberApiArg = {
  id: string;
};
export type TranscriberListControllerAdminTranscriberListApiResponse =
  /** status 200  */ TranscriberResponseDto[];
export type TranscriberListControllerAdminTranscriberListApiArg = void;
export type TranscriberCreateControllerCreateTranscriberApiResponse =
  /** status 201  */ TranscriberResponseDto;
export type TranscriberCreateControllerCreateTranscriberApiArg = {
  transcriberRequestDto: TranscriberRequestDto;
};
export type TranscriberControllerGetTranscriberApiResponse =
  /** status 200  */ TranscriberResponseDto;
export type TranscriberControllerGetTranscriberApiArg = {
  id: string;
};
export type TranscriberDeleteControllerDeleteTranscriberApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type TranscriberDeleteControllerDeleteTranscriberApiArg = {
  id: string;
};
export type TranscriberEditControllerEditTranscriberApiResponse =
  /** status 200  */ TranscriberResponseDto;
export type TranscriberEditControllerEditTranscriberApiArg = {
  id: string;
  transcriberRequestDto: TranscriberRequestDto;
};
export type CreateCompanyControllerCreateCompanyApiResponse = /** status 201  */ CompanyDto;
export type CreateCompanyControllerCreateCompanyApiArg = {
  createCompanyRequestDto: CreateCompanyRequestDto;
};
export type CompanyControllerGetCompanyApiResponse = /** status 200  */ CompanyDto;
export type CompanyControllerGetCompanyApiArg = {
  id: string;
};
export type CompanyControllerGetCompanyAsAdminApiResponse = /** status 200  */ CompanyDto;
export type CompanyControllerGetCompanyAsAdminApiArg = {
  id: string;
};
export type EditCompanyControllerEditCompanyApiResponse = /** status 200  */ CompanyDto;
export type EditCompanyControllerEditCompanyApiArg = {
  id: string;
  editCompanyRequestDto: EditCompanyRequestDto;
};
export type GetAllCompanyIdsControllerGetAllCompanyIdsApiResponse = /** status 200  */ string[];
export type GetAllCompanyIdsControllerGetAllCompanyIdsApiArg = void;
export type CompanyApiKeyCreateControllerApiKeyCreateApiResponse =
  /** status 201  */ CompanyApiKeyCreateResponseDto;
export type CompanyApiKeyCreateControllerApiKeyCreateApiArg = {
  id: string;
};
export type CompanyApiKeyRevokeControllerApiKeyRevokeApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CompanyApiKeyRevokeControllerApiKeyRevokeApiArg = {
  id: string;
  apiKeyId: string;
};
export type AgentProfileCreateControllerAgentProfileCreateForUsersApiResponse =
  /** status 201  */ AgentProfileResponseDto;
export type AgentProfileCreateControllerAgentProfileCreateForUsersApiArg = {
  agentProfileCreateRequestDto: AgentProfileCreateRequestDto;
};
export type AgentProfileListControllerAgentProfileListForUsersApiResponse =
  /** status 200  */ AgentProfileResponseDto[];
export type AgentProfileListControllerAgentProfileListForUsersApiArg = {
  /** Filter agent profiles by type. Can be a single value (system, custom, customer-template) or comma-separated values (e.g., system,custom). If not specified, returns all profiles. */
  filter?: string;
};
export type AgentProfileCreateControllerAgentProfileCreateForManagersApiResponse =
  /** status 201  */ AgentProfileResponseDto;
export type AgentProfileCreateControllerAgentProfileCreateForManagersApiArg = {
  id: string;
  agentProfileCreateAdminRequestDto: AgentProfileCreateAdminRequestDto;
};
export type AgentProfileListControllerAgentProfileListForAdminsApiResponse =
  /** status 200  */ AgentProfileResponseDto[];
export type AgentProfileListControllerAgentProfileListForAdminsApiArg = {
  id: string;
  /** Filter agent profiles by type. Can be a single value (system, custom, customer-template) or comma-separated values (e.g., system,custom). If not specified, returns all profiles. */
  filter?: string;
};
export type AgentProfileEditControllerAgentProfileEditForUsersApiResponse =
  /** status 200  */ AgentProfileResponseDto;
export type AgentProfileEditControllerAgentProfileEditForUsersApiArg = {
  profileId: string;
  agentProfileEditRequestDto: AgentProfileEditRequestDto;
};
export type AgentProfileDeleteControllerAgentProfileDeleteForUsersApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type AgentProfileDeleteControllerAgentProfileDeleteForUsersApiArg = {
  profileId: string;
};
export type AgentProfileEditControllerAgentProfileEditForManagersApiResponse =
  /** status 200  */ AgentProfileResponseDto;
export type AgentProfileEditControllerAgentProfileEditForManagersApiArg = {
  id: string;
  profileId: string;
  agentProfileEditRequestDto: AgentProfileEditRequestDto;
};
export type AgentProfileDeleteControllerAgentProfileDeleteForManagersApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type AgentProfileDeleteControllerAgentProfileDeleteForManagersApiArg = {
  id: string;
  profileId: string;
};
export type CompanyOverviewControllerGetCompanyOverviewApiResponse =
  /** status 200  */ CompanyOverviewResponseDto;
export type CompanyOverviewControllerGetCompanyOverviewApiArg = void;
export type CompanyListControllerCompanyListApiResponse = /** status 200  */ CompanyDto[];
export type CompanyListControllerCompanyListApiArg = void;
export type UsageLimitControllerUsageLimitsApiResponse =
  /** status 200  */ RemainingLimitResponseDto;
export type UsageLimitControllerUsageLimitsApiArg = void;
export type UsageLimitControllerAdminUsageLimitsApiResponse =
  /** status 200  */ RemainingLimitResponseDto;
export type UsageLimitControllerAdminUsageLimitsApiArg = {
  id: string;
};
export type UsageLimitSetControllerSetLimitsApiResponse =
  /** status 200  */ UsageLimitResponseDto[];
export type UsageLimitSetControllerSetLimitsApiArg = {
  id: string;
  usageLimitSetRequestDto: UsageLimitSetRequestDto;
};
export type UsageLimitControllerSystemUsageLimitsApiResponse =
  /** status 200  */ RemainingLimitResponseDto;
export type UsageLimitControllerSystemUsageLimitsApiArg = {
  id: string;
};
export type CompanyVoicesSetControllerSetCompanyVoicesApiResponse = /** status 200  */ CompanyDto;
export type CompanyVoicesSetControllerSetCompanyVoicesApiArg = {
  id: string;
  companyVoicesSetRequestDto: CompanyVoicesSetRequestDto;
};
export type CompanyTranscribersSetControllerSetCompanyTranscribersApiResponse =
  /** status 200  */ CompanyDto;
export type CompanyTranscribersSetControllerSetCompanyTranscribersApiArg = {
  id: string;
  companyTranscribersSetRequestDto: CompanyTranscribersSetRequestDto;
};
export type CompanyLlmProvidersSetControllerSetCompanyLlmProvidersApiResponse =
  /** status 200  */ CompanyDto;
export type CompanyLlmProvidersSetControllerSetCompanyLlmProvidersApiArg = {
  id: string;
  companyLlmProvidersSetRequestDto: CompanyLlmProvidersSetRequestDto;
};
export type ConcurrentLimitSetControllerSetConcurrentLimitApiResponse =
  /** status 200  */ ConcurrentLimitSetResponseDto;
export type ConcurrentLimitSetControllerSetConcurrentLimitApiArg = {
  id: string;
  concurrentLimitSetRequestDto: ConcurrentLimitSetRequestDto;
};
export type UnitWeightsControllerGetUnitWeightsApiResponse =
  /** status 200  */ UnitWeightsResponseDto[];
export type UnitWeightsControllerGetUnitWeightsApiArg = void;
export type UnitWeightsSetControllerSetUnitWeightsApiResponse =
  /** status 200  */ UnitWeightsResponseDto[];
export type UnitWeightsSetControllerSetUnitWeightsApiArg = {
  unitWeightsSetRequestDto: UnitWeightsSetRequestDto;
};
export type LivekitControllerWebhookApiResponse = unknown;
export type LivekitControllerWebhookApiArg = void;
export type CampaignPostCallMessageCreateControllerCreateApiResponse =
  /** status 201  */ CampaignPostCallMessageResponseDto;
export type CampaignPostCallMessageCreateControllerCreateApiArg = {
  campaignId: string;
  campaignPostCallMessageCreateRequestDto: CampaignPostCallMessageCreateRequestDto;
};
export type CampaignPostCallMessagesControllerListApiResponse =
  /** status 200  */ CampaignPostCallMessageResponseDto[];
export type CampaignPostCallMessagesControllerListApiArg = {
  campaignId: string;
};
export type CampaignPostCallMessageUpdateControllerUpdateApiResponse =
  /** status 200  */ CampaignPostCallMessageResponseDto;
export type CampaignPostCallMessageUpdateControllerUpdateApiArg = {
  campaignId: string;
  messageId: string;
  campaignPostCallMessageUpdateRequestDto: CampaignPostCallMessageUpdateRequestDto;
};
export type CampaignPostCallMessageDeleteControllerDeleteApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CampaignPostCallMessageDeleteControllerDeleteApiArg = {
  campaignId: string;
  messageId: string;
};
export type MessageDeliverySweepControllerSystemDeliverySweepApiResponse =
  /** status 201  */ object;
export type MessageDeliverySweepControllerSystemDeliverySweepApiArg = void;
export type MessageDeliveryUpdateControllerWebhookApiResponse = /** status 201  */ string;
export type MessageDeliveryUpdateControllerWebhookApiArg = {
  token: string;
};
export type FileCreateControllerCreateApiResponse = /** status 201  */ FileResponseDto;
export type FileCreateControllerCreateApiArg = {
  fileCreateRequestDto: FileCreateRequestDto;
};
export type FileListControllerListApiResponse = /** status 200  */ FileResponseDto[];
export type FileListControllerListApiArg = void;
export type FileDeleteControllerDeleteApiResponse = /** status 200  */ BaseOkResponseDto;
export type FileDeleteControllerDeleteApiArg = {
  id: string;
};
export type FileControllerGetApiResponse = /** status 200  */ FileResponseDto;
export type FileControllerGetApiArg = {
  id: string;
};
export type SquadCreateControllerExecuteApiResponse = /** status 201  */ SquadDto;
export type SquadCreateControllerExecuteApiArg = {
  id: string;
  squadCreateRequestDto: SquadCreateRequestDto;
};
export type SquadDeleteControllerExecuteApiResponse = unknown;
export type SquadDeleteControllerExecuteApiArg = {
  id: string;
};
export type SquadAgentCreateControllerExecuteApiResponse = /** status 201  */ SquadAgentResponseDto;
export type SquadAgentCreateControllerExecuteApiArg = {
  id: string;
  agentRequestDto: AgentRequestDto;
};
export type SquadAgentUpdateControllerExecuteApiResponse = /** status 200  */ SquadAgentResponseDto;
export type SquadAgentUpdateControllerExecuteApiArg = {
  id: string;
  agentId: string;
  squadAgentUpdateRequestDto: SquadAgentUpdateRequestDto;
};
export type SquadAgentDeleteControllerExecuteApiResponse =
  /** status 200  */ SquadAgentDeleteResponseDto;
export type SquadAgentDeleteControllerExecuteApiArg = {
  id: string;
  agentId: string;
};
export type HandoffRuleCreateControllerExecuteApiResponse =
  /** status 201  */ HandoffRuleResponseDto[];
export type HandoffRuleCreateControllerExecuteApiArg = {
  id: string;
  body: HandoffRuleRequestDto[];
};
export type StructuredOutputCreateControllerCreateApiResponse =
  /** status 201  */ StructuredOutputDto;
export type StructuredOutputCreateControllerCreateApiArg = {
  structuredOutputCreateRequestDto: StructuredOutputCreateRequestDto;
};
export type StructuredOutputListControllerListApiResponse =
  /** status 200  */ StructuredOutputDto[];
export type StructuredOutputListControllerListApiArg = void;
export type StructuredOutputUpdateControllerUpdateApiResponse =
  /** status 200  */ StructuredOutputDto;
export type StructuredOutputUpdateControllerUpdateApiArg = {
  id: string;
  structuredOutputUpdateRequestDto: StructuredOutputUpdateRequestDto;
};
export type StructuredOutputDeleteControllerDeleteApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type StructuredOutputDeleteControllerDeleteApiArg = {
  id: string;
};
export type StructuredOutputControllerGetApiResponse = /** status 200  */ StructuredOutputDto;
export type StructuredOutputControllerGetApiArg = {
  id: string;
};
export type StructuredOutputTemplateListControllerListApiResponse =
  /** status 200  */ StructuredOutputDto[];
export type StructuredOutputTemplateListControllerListApiArg = void;
export type StructuredOutputTemplateControllerGetApiResponse =
  /** status 200  */ StructuredOutputDto;
export type StructuredOutputTemplateControllerGetApiArg = {
  id: string;
};
export type CampaignStructuredOutputAttachControllerAttachApiResponse =
  /** status 201  */ StructuredOutputDto[];
export type CampaignStructuredOutputAttachControllerAttachApiArg = {
  id: string;
  campaignStructuredOutputAttachRequestDto: CampaignStructuredOutputAttachRequestDto;
};
export type CampaignStructuredOutputListControllerListApiResponse =
  /** status 200  */ StructuredOutputDto[];
export type CampaignStructuredOutputListControllerListApiArg = {
  id: string;
};
export type CampaignStructuredOutputDetachControllerDetachApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CampaignStructuredOutputDetachControllerDetachApiArg = {
  id: string;
  outputId: string;
};
export type ToolCreateControllerCreateCampaignToolApiResponse = /** status 201  */ ToolDto;
export type ToolCreateControllerCreateCampaignToolApiArg = {
  id: string;
  toolRequestDto: ToolRequestDto;
};
export type ToolListControllerCampaignToolListApiResponse = /** status 200  */ ToolDto[];
export type ToolListControllerCampaignToolListApiArg = {
  id: string;
};
export type ToolCreateControllerCreateAgentToolApiResponse = /** status 201  */ ToolDto;
export type ToolCreateControllerCreateAgentToolApiArg = {
  id: string;
  toolRequestDto: ToolRequestDto;
};
export type ToolListControllerAgentTollListApiResponse = /** status 200  */ ToolDto[];
export type ToolListControllerAgentTollListApiArg = {
  id: string;
};
export type ToolUpdateControllerCreateCampaignToolApiResponse = /** status 200  */ ToolDto;
export type ToolUpdateControllerCreateCampaignToolApiArg = {
  id: string;
  toolId: string;
  toolUpdateRequestDto: ToolUpdateRequestDto;
};
export type ToolDeleteControllerCreateCampaignToolApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type ToolDeleteControllerCreateCampaignToolApiArg = {
  id: string;
  toolId: string;
};
export type ToolUpdateControllerCreateAgentToolApiResponse = /** status 200  */ ToolDto;
export type ToolUpdateControllerCreateAgentToolApiArg = {
  id: string;
  toolId: string;
  toolUpdateRequestDto: ToolUpdateRequestDto;
};
export type ToolDeleteControllerCreateAgentToolApiResponse = /** status 200  */ BaseOkResponseDto;
export type ToolDeleteControllerCreateAgentToolApiArg = {
  id: string;
  toolId: string;
};
export type LlmProviderListControllerProviderListApiResponse = /** status 200  */ LlmProviderDto[];
export type LlmProviderListControllerProviderListApiArg = void;
export type LlmProviderListControllerAdminProviderListApiResponse =
  /** status 200  */ LlmProviderDto[];
export type LlmProviderListControllerAdminProviderListApiArg = void;
export type LlmModelListControllerModelListApiResponse = /** status 200  */ LlmModelDto[];
export type LlmModelListControllerModelListApiArg = {
  id: string;
};
export type LlmModelListControllerAdminModelListApiResponse = /** status 200  */ LlmModelDto[];
export type LlmModelListControllerAdminModelListApiArg = {
  id: string;
};
export type CampaignWebhookCreateControllerCreateApiResponse =
  /** status 201  */ CampaignWebhookResponseDto;
export type CampaignWebhookCreateControllerCreateApiArg = {
  campaignId: string;
  campaignWebhookCreateRequestDto: CampaignWebhookCreateRequestDto;
};
export type CampaignWebhooksControllerListApiResponse =
  /** status 200  */ CampaignWebhookResponseDto[];
export type CampaignWebhooksControllerListApiArg = {
  campaignId: string;
};
export type CampaignWebhookUpdateControllerUpdateApiResponse =
  /** status 200  */ CampaignWebhookResponseDto;
export type CampaignWebhookUpdateControllerUpdateApiArg = {
  campaignId: string;
  webhookId: string;
  campaignWebhookUpdateRequestDto: CampaignWebhookUpdateRequestDto;
};
export type CampaignWebhookDeleteControllerDeleteApiResponse = /** status 200  */ BaseOkResponseDto;
export type CampaignWebhookDeleteControllerDeleteApiArg = {
  campaignId: string;
  webhookId: string;
};
export type CampaignWebhookDispatchControllerManualDispatchApiResponse = /** status 201  */ object;
export type CampaignWebhookDispatchControllerManualDispatchApiArg = {
  campaignId: string;
  callId: string;
};
export type CampaignWebhookDispatchControllerSystemDispatchApiResponse = /** status 201  */ object;
export type CampaignWebhookDispatchControllerSystemDispatchApiArg = {
  campaignId: string;
  callId: string;
};
export type WebhookDeliverySweepControllerSystemDeliverySweepApiResponse =
  /** status 201  */ object;
export type WebhookDeliverySweepControllerSystemDeliverySweepApiArg = void;
export type HealthControllerCheckApiResponse = /** status 200 The Health Check is successful */ {
  status?: string;
  info?: {
    [key: string]: {
      status: string;
      [key: string]: any;
    };
  } | null;
  error?: {
    [key: string]: {
      status: string;
      [key: string]: any;
    };
  } | null;
  details?: {
    [key: string]: {
      status: string;
      [key: string]: any;
    };
  };
};
export type HealthControllerCheckApiArg = void;
export type UsageMonitoringControllerGetUsageApiResponse = /** status 200  */ UsageResponseDto;
export type UsageMonitoringControllerGetUsageApiArg = void;
export type AccessTokenResponseDto = {
  accessToken: string;
};
export type SignInRequestDto = {
  login: string;
  password: string;
};
export type ApiKeyDto = {
  jti: string;
  subType: 'user' | 'refresh' | 'external';
  subId: string;
  issuedAt: string;
  expiresAt: string;
  isRevoked: boolean;
};
export type ForgotPasswordResponseDto = {
  message: string;
};
export type ForgotPasswordRequestDto = {
  email: string;
};
export type ResetPasswordResponseDto = {
  message: string;
};
export type ResetPasswordRequestDto = {
  token: string;
  password: string;
};
export type UserRoles = 'admin' | 'viewer';
export type UserDto = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRoles;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  companyId: string;
};
export type EditUserRequestDto = {
  firstName: string;
  lastName: string;
  role: UserRoles;
  password?: string;
};
export type UserCreateRequestDto = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  role: UserRoles;
  companyId: string;
};
export type AdminRoles = 'manager';
export type AdminDto = {
  id: string;
  email: string;
  role: AdminRoles;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};
export type Analysis = {
  id: string;
  createdAt: string;
  updatedAt: string;
  summary: {
    [key: string]: any;
  } | null;
  detailedSummary: {
    [key: string]: any;
  } | null;
  status: 'queued' | 'failed' | 'completed';
  callId: string;
};
export type CallAnalysisCreateRequestDto = {
  /** Final callback status from the analysis service. */
  status?: 'completed' | 'failed';
  /** Analysis summary payload as stringified JSON or plain text. */
  summary?: string;
};
export type SentimentType = 'positive' | 'negative' | 'neutral';
export type SentimentScoreDto = {
  label: SentimentType;
  score: number;
};
export type SentimentDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  callId: string;
  sentimentScores: SentimentScoreDto[];
};
export type SentimentScoreRequestDto = {
  label: SentimentType;
  score: number;
};
export type SentimentRequestDto = {
  id?: string;
  sentimentScores: SentimentScoreRequestDto[];
  createdAt: string;
};
export type CallType = 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
export type CallStatus =
  | 'pending'
  | 'scheduled'
  | 'ended'
  | 'queued'
  | 'initializing'
  | 'ringing'
  | 'in-progress';
export type CallEndedReason =
  | 'agent-detected-end-call-phrase'
  | 'agent-join-timed-out'
  | 'customer-busy'
  | 'customer-unavailable'
  | 'customer-ended-call'
  | 'manually-canceled'
  | 'internal-error'
  | 'unknown-reason'
  | 'error-sip-telephony-provider-failed-to-connect-call'
  | 'error-sip-provider-declined'
  | 'usage-limits-exceeded'
  | 'concurrent-limit-reached'
  | 'agent-forwarded-call'
  | 'transfer-failed'
  | 'participant-removed'
  | 'customer-did-not-join'
  | 'worker-crashed'
  | 'stale-timeout';
export type CustomerDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  number?: string;
  name?: string | null;
  gender?: string | null;
  attributes?: object;
  metadata?: object;
  campaignId?: string;
};
export type LlmProviderDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  key: string;
  title: string;
  baseUrl?: string | null;
  apiKey?: string | null;
  /** Whether this provider allows user-defined/custom models */
  allowsCustomModels: boolean;
};
export type LlmModelDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  key: string;
  title: string;
};
export type ElevenLabsTtsModel =
  | 'eleven_multilingual_v2'
  | 'eleven_turbo_v2'
  | 'eleven_turbo_v2_5'
  | 'eleven_flash_v2'
  | 'eleven_flash_v2_5'
  | 'eleven_monolingual_v1';
export type ElevenLabsSettingsDto = {
  model?: ElevenLabsTtsModel;
  /** Defines the similarity boost for voice settings. */
  similarityBoost?: number;
  /** Defines the stability for voice settings. */
  stability?: number;
  /** Defines the use speaker boost for voice settings. */
  useSpeakerBoost?: boolean;
  /** Defines the style for voice settings. */
  style?: number;
  /** This is the language (ISO 639-1) that is enforced for the model. Only Turbo v2.5 supports language enforcement. */
  language?: string;
};
export type PlayAiTtsModel = 'Play3.0-mini' | 'PlayDialog' | 'PlayDialog-turbo';
export type PlayAiSettingsDto = {
  model: PlayAiTtsModel;
  /** Language for TTS (e.g., “english”). */
  language?: string;
  /** Sampling rate of the generated audio, in Hz (e.g., 8000, 22050, 44100). */
  sampleRate?: number;
};
export type HamsaSettingsDto = {
  /** This is the model that will be used. */
  speaker: string;
  /** Speaker dialect (e.g., leb). */
  dialect: string;
  /** Use Mu-law or not */
  mulaw: boolean;
};
export type VoiceDto = {
  id: string;
  /** This is the provider-specific ID that will be used. Ensure the Voice is present in your 11Labs Voice Library. */
  voiceId?: string;
  /** Voice provider identifier. Can be one of the known providers (11labs, playai, hamsa) or any custom string. */
  provider: string;
  /** Custom label for the provider when pseudonymization is required. Falls back to provider when unset. */
  providerDisplayName?: string;
  name: string;
  previewUrl?: string;
  gender?: string;
  accent?: string;
  baseUrl?: string | null;
  apiKey?: string | null;
  voiceSettings: ElevenLabsSettingsDto | PlayAiSettingsDto | HamsaSettingsDto;
  createdAt: string;
  updatedAt: string;
};
export type TaskFlowSchemaPropertyDto = {
  type: 'string' | 'integer' | 'number' | 'boolean';
  description?: string;
};
export type TaskFlowSchemaDto = {
  properties: {
    [key: string]: TaskFlowSchemaPropertyDto;
  };
  required?: string[];
};
export type CollectDataTaskDto = {
  id: string;
  description: string;
  instructions?: string | null;
  type: 'collect_data';
  schemaType?: 'json_schema';
  schema?: TaskFlowSchemaDto | null;
};
export type DtmfTaskDto = {
  id: string;
  description: string;
  instructions?: string | null;
  type: 'get_dtmf';
  /** Required integer number of DTMF digits */
  numDigits: number;
  /** Optional DTMF input timeout in seconds */
  dtmfInputTimeout?: number;
  /** DTMF terminator */
  dtmfStopEvent?: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '*' | '#';
  askForConfirmation?: boolean;
};
export type SimpleTaskDto = {
  id: string;
  description: string;
  instructions?: string | null;
  type: 'get_email' | 'get_phone' | 'get_name' | 'get_dob' | 'get_address';
};
export type TaskFlowDto = {
  id: string;
  autoStart?: boolean;
  summarizeChatCtx?: boolean;
  returnExceptions?: boolean;
  tasks: (CollectDataTaskDto | DtmfTaskDto | SimpleTaskDto)[];
};
export type AgentProfileType = 'system' | 'custom' | 'customer-template';
export type AgentProfileResponseDto = {
  id: string;
  name: string;
  prompt?: string;
  firstMessage?: string | null;
  taskFlow: TaskFlowDto | null;
  firstMessageInterruptionsEnabled: boolean;
  type: AgentProfileType;
};
export type ProviderType = 'azure' | 'deepgram' | 'hamsa' | 'openai';
export type LanguageType = 'ar-SA' | 'en-US' | 'fr-FR' | 'ch-CN';
export type TranscriberResponseDto = {
  id: string;
  provider: ProviderType;
  /** Custom label for the provider when pseudonymization is required. Falls back to provider when unset. */
  providerDisplayName?: string;
  language: LanguageType;
  model?: string | null;
  baseUrl?: string | null;
  apiKey?: string | null;
  createdAt?: string;
  updatedAt?: string;
};
export type ToolType =
  | 'end-call'
  | 'voice-mail-detection'
  | 'transfer-call'
  | 'mcp'
  | 'generate-whatsapp-message'
  | 'call-handoff-signal'
  | 'gender-detection'
  | 'request-callback'
  | 'whatsapp-message-send';
export type ToolDto = {
  id: string;
  campaignId?: string;
  agentId?: string;
  type: ToolType;
  isAsync: boolean;
  messageTemplate?: string;
  inputSchema?: object;
  avatarSettings?: object;
  phoneNumbers?: string[];
  genderSettings?: object;
  mcpName?: string;
  mcpServerConfig: object;
};
export type AgentIdleStateResponseDto = {
  enabled: boolean;
  delayMs: number;
  messages: string[];
  customerSilenceMessages: string[];
  customerEndCallMessages: string[];
  customerReplyTimeoutSec?: number | null;
  customerSilenceThresholdSec?: number | null;
  customerMaxAttempts?: number | null;
};
export type BackgroundSoundDto = {
  id?: string;
  source?: string;
};
export type AmbientSoundResponseDto = {
  sound: BackgroundSoundDto;
  volume: number;
};
export type ThinkingSoundResponseDto = {
  sound: BackgroundSoundDto;
  volume: number;
  probability: number;
};
export type AgentBackgroundSoundsResponseDto = {
  ambientSound?: AmbientSoundResponseDto;
  thinkingSounds?: ThinkingSoundResponseDto[];
};
export type SquadAgentResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  llmProviderId: string;
  llmProvider?: LlmProviderDto | null;
  llmModelId?: string | null;
  llmModel?: LlmModelDto | null;
  llmCustomModelKey?: string | null;
  voiceId: string;
  voice?: VoiceDto | null;
  profileId?: string | null;
  profile?: AgentProfileResponseDto | null;
  transcriberId: string;
  transcriber?: TranscriberResponseDto | null;
  languages?: string[];
  tools?: ToolDto[];
  avatarUrl?: string | null;
  metadata?: object | null;
  idleState?: AgentIdleStateResponseDto;
  backgroundSounds?: AgentBackgroundSoundsResponseDto | null;
  isDefault: boolean;
};
export type HandoffRuleMessagesResponseDto = {
  start?: string[];
  delayed?: string[];
  complete?: string[];
  failed?: string[];
};
export type ContextPropagationPlanType = 'lastNMessages' | 'all';
export type ContextPropagationPlanResponseDto = {
  type: ContextPropagationPlanType;
  maxMessages?: number;
};
export type HandoffRuleResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  squadId: string;
  name?: string | null;
  description?: string | null;
  fromAgentId: string;
  toAgentId: string;
  messages?: HandoffRuleMessagesResponseDto | null;
  contextPropagationPlan?: ContextPropagationPlanResponseDto | null;
  variableExtractionPlan?: object | null;
};
export type SquadDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description?: string | null;
  companyId: string;
  agents: SquadAgentResponseDto[];
  handoffRules: HandoffRuleResponseDto[];
};
export type AgentDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  llmProviderId: string;
  llmProvider?: LlmProviderDto | null;
  llmModelId?: string | null;
  llmModel?: LlmModelDto | null;
  llmCustomModelKey?: string | null;
  voiceId: string;
  voice?: VoiceDto | null;
  profileId?: string | null;
  profile?: AgentProfileResponseDto | null;
  transcriberId: string;
  transcriber?: TranscriberResponseDto | null;
  languages?: string[];
  tools?: ToolDto[];
  avatarUrl?: string | null;
  metadata?: object | null;
  idleState?: AgentIdleStateResponseDto;
  backgroundSounds?: AgentBackgroundSoundsResponseDto | null;
};
export type CallDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name?: string;
  type: CallType;
  roomName: string;
  status: CallStatus;
  endedReason?: CallEndedReason;
  startedAt?: string;
  endedAt?: string;
  customerId?: string;
  agentId?: string;
  squadId?: string;
  companyId: string;
  sentiments?: SentimentDto[];
  customer?: CustomerDto;
  recordingUrl?: string;
  agentProfileName?: string | null;
  squad?: SquadDto;
  agent?: AgentDto;
  analysisStatus: ('queued' | 'failed' | 'completed') | null;
  analysis: {
    [key: string]: any;
  } | null;
};
export type CallRequestDto = {
  status: CallStatus;
  endedReason?: CallEndedReason;
  startedAt?: string;
  endedAt?: string;
  roomName?: string;
  name?: string;
  recordingUrl?: string;
};
export type CallSupervisorModeDto = {
  mode: 'listen' | 'barge';
  updatedAt: string;
};
export type CallSupervisorModeRequestDto = {
  mode: 'listen' | 'barge';
  identity: string;
};
export type CampaignTestCallCreateResponseDto = {
  call: CallDto;
  token: string;
};
export type CampaignTestCallCreateRequestDto = {
  callType: CallType;
  agentId?: string;
  squadId?: string;
  phoneNumber?: string;
  name?: string;
  gender?: 'male' | 'female';
  attributes?: {
    [key: string]: any;
  };
  /** just ignor that field */
  _dummyProperty?: object;
};
export type CallCreateExternalCustomerDto = {
  number?: string;
  name?: string | null;
  gender?: ('male' | 'female') | null;
  attributes?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
  /** ISO8601 datetime. When to dial the customer. If the value has no timezone offset (e.g. "2026-06-10T15:00:00"), it is interpreted in the campaign schedule timezone; otherwise the embedded offset is used. */
  timeToDial?: string;
};
export type CallCreateExternalRequestDto = {
  customers: CallCreateExternalCustomerDto[];
};
export type CampaignCloneRequestDto = {
  title?: string;
};
export type CampaignStatus = 'active' | 'inactive';
export type CampaignType = 'inbound' | 'outbound';
export type CallScheduleDto = {
  mondayStart?: string | null;
  mondayEnd?: string | null;
  tuesdayStart?: string | null;
  tuesdayEnd?: string | null;
  wednesdayStart?: string | null;
  wednesdayEnd?: string | null;
  thursdayStart?: string | null;
  thursdayEnd?: string | null;
  fridayStart?: string | null;
  fridayEnd?: string | null;
  saturdayStart?: string | null;
  saturdayEnd?: string | null;
  sundayStart?: string | null;
  sundayEnd?: string | null;
  timezone?: string;
};
export type SipTrunkDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: object;
  campaignId: string;
  sipTrunkId?: string | null;
};
export type AnalysisPlanDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  summaryPrompt: string;
  analysisTemplate?: string;
};
export type StructuredOutputDriver = 'baml' | 'custom';
export type StructuredOutputDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  companyId?: string | null;
  driver: StructuredOutputDriver;
  name: string;
  description: string;
  instructions?: string | null;
  schema: string;
};
export type AnalysisTriggerType = 'call-end' | 'scheduled';
export type NoiseGuardResponseDto = {
  enabled: boolean;
  shadowMode: boolean;
  hangupEnabled: boolean;
  triggers?: {
    [key: string]: any;
  };
};
export type NoiseCancellationSettingsResponseDto = {
  enabled: boolean;
  provider: string;
  strength?: number;
  recordAudio?: boolean;
  noiseDetection?: {
    [key: string]: any;
  };
};
export type CampaignNoiseProcessingResponseDto = {
  noiseGuard: NoiseGuardResponseDto | null;
  noiseCancellationSettings: NoiseCancellationSettingsResponseDto | null;
};
export type PreemptiveGenerationResponseDto = {
  enabled?: boolean;
  preemptiveTts?: boolean;
  maxSpeechDuration?: number;
  maxRetries?: number;
};
export type TurnHandlingResponseDto = {
  minEndpointingDelay?: number;
  maxEndpointingDelay?: number;
  turnDetection?: string;
  endpointingMode?: 'fixed' | 'dynamic';
  interruptionEnabled?: boolean;
  interruptionMode?: 'vad' | 'adaptive';
  minInterruptionWords?: number;
  minInterruptionDuration?: number;
  falseInterruptionTimeout?: number;
  resumeFalseInterruption?: boolean;
  preemptiveGeneration?: PreemptiveGenerationResponseDto;
};
export type SpeechPacingResponseDto = {
  enabled?: boolean;
  phraseBoundaryDelayMs?:
    | number
    | {
        minMs: number;
        maxMs: number;
      };
  sentenceBoundaryDelayMs?:
    | number
    | {
        minMs: number;
        maxMs: number;
      };
  seed?: string;
};
export type CampaignBackgroundSoundsResponseDto = {
  overrideAmbientSound: boolean;
  overrideThinkingSounds: boolean;
  ambientSound?: AmbientSoundResponseDto;
  thinkingSounds?: ThinkingSoundResponseDto[];
};
export type CampaignDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  companyId: string;
  status: CampaignStatus;
  title: string;
  type: CampaignType;
  description?: string | null;
  retryIntervalInMinutes?: number | null;
  retryMaxNumber?: number | null;
  retriesPerDay?: number | null;
  productDetails?: string | null;
  callSchedule?: CallScheduleDto;
  sipTrunks?: SipTrunkDto[];
  analysisPlan?: AnalysisPlanDto;
  structuredOutputs?: StructuredOutputDto[];
  tools?: ToolDto[];
  fileIds?: string[];
  reservedLimit: number;
  analysisTriggerType: AnalysisTriggerType;
  agentsCount: number;
  customersTotal?: number;
  squadId?: string;
  noiseProcessing: CampaignNoiseProcessingResponseDto;
  turnHandling: TurnHandlingResponseDto | null;
  speechPacing: SpeechPacingResponseDto | null;
  backgroundSounds?: CampaignBackgroundSoundsResponseDto | null;
  squad?: SquadDto | null;
};
export type NoiseGuardRequestDto = {
  enabled: boolean;
  shadowMode: boolean;
  hangupEnabled: boolean;
  triggers?: {
    [key: string]: any;
  };
};
export type NoiseCancellationSettingsRequestDto = {
  enabled: boolean;
  provider: string;
  strength?: number;
  recordAudio?: boolean;
  noiseDetection?: {
    [key: string]: any;
  };
};
export type CampaignNoiseProcessingRequestDto = {
  noiseGuard?: NoiseGuardRequestDto | null;
  noiseCancellationSettings?: NoiseCancellationSettingsRequestDto | null;
};
export type CustomerRequestDto = {
  id?: string;
  number?: string;
  name?: string | null;
  gender?: ('male' | 'female') | null;
  attributes?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
};
export type CallScheduleRequestDto = {
  mondayStart?: string | null;
  mondayEnd?: string | null;
  tuesdayStart?: string | null;
  tuesdayEnd?: string | null;
  wednesdayStart?: string | null;
  wednesdayEnd?: string | null;
  thursdayStart?: string | null;
  thursdayEnd?: string | null;
  fridayStart?: string | null;
  fridayEnd?: string | null;
  saturdayStart?: string | null;
  saturdayEnd?: string | null;
  sundayStart?: string | null;
  sundayEnd?: string | null;
  timezone?: string;
};
export type CampaignCreateRequestDto = {
  title: string;
  type: CampaignType;
  description?: string | null;
  retryIntervalInMinutes?: number | null;
  retryMaxNumber?: number | null;
  retriesPerDay?: number | null;
  productDetails?: string | null;
  reservedLimit?: number;
  analysisTriggerType?: AnalysisTriggerType;
  noiseProcessing?: CampaignNoiseProcessingRequestDto | null;
  customers?: CustomerRequestDto[];
  callSchedule?: CallScheduleRequestDto;
};
export type BaseOkResponseDto = {
  ok: boolean;
};
export type AnalysisPlanRequestDto = {
  summaryPrompt: string;
  analysisTemplate?: string;
};
export type ToolRequestDto = {
  id?: string;
  /** Agent ID to attach tool to agent instead of campaign */
  agentId?: string;
  type: ToolType;
  isAsync: boolean;
  messageTemplate?: string | null;
  phoneNumbers?: string[] | null;
  mcpName?: string | null;
  mcpServerConfig?: object;
  genderSettings?: object | null;
};
export type AmbientSoundRequestDto = {
  soundId: string;
  volume: number;
};
export type ThinkingSoundRequestDto = {
  soundId: string;
  volume: number;
  probability: number;
};
export type CampaignBackgroundSoundsRequestDto = {
  overrideAmbientSound?: boolean;
  overrideThinkingSounds?: boolean;
  ambientSound?: AmbientSoundRequestDto | null;
  thinkingSounds?: ThinkingSoundRequestDto[];
};
export type PreemptiveGenerationRequestDto = {
  enabled?: boolean;
  preemptiveTts?: boolean;
  maxSpeechDuration?: number;
  maxRetries?: number;
};
export type TurnHandlingRequestDto = {
  minEndpointingDelay?: number;
  maxEndpointingDelay?: number;
  turnDetection?: string;
  endpointingMode?: 'fixed' | 'dynamic';
  interruptionEnabled?: boolean;
  interruptionMode?: 'vad' | 'adaptive';
  minInterruptionWords?: number;
  minInterruptionDuration?: number;
  falseInterruptionTimeout?: number;
  resumeFalseInterruption?: boolean;
  preemptiveGeneration?: PreemptiveGenerationRequestDto;
};
export type SpeechPacingRequestDto = {
  enabled?: boolean;
  phraseBoundaryDelayMs?:
    | number
    | {
        minMs: number;
        maxMs: number;
      };
  sentenceBoundaryDelayMs?:
    | number
    | {
        minMs: number;
        maxMs: number;
      };
  seed?: string;
};
export type CampaignUpdateRequestDto = {
  title?: string;
  description?: string | null;
  retryIntervalInMinutes?: number | null;
  retryMaxNumber?: number | null;
  retriesPerDay?: number | null;
  productDetails?: string | null;
  reservedLimit?: number;
  analysisTriggerType?: AnalysisTriggerType;
  noiseProcessing?: CampaignNoiseProcessingRequestDto | null;
  customers?: CustomerRequestDto[];
  callSchedule?: CallScheduleRequestDto;
  analysisPlan?: AnalysisPlanRequestDto | null;
  tools?: ToolRequestDto[];
  backgroundSounds?: CampaignBackgroundSoundsRequestDto;
  turnHandling?: TurnHandlingRequestDto | null;
  speechPacing?: SpeechPacingRequestDto | null;
};
export type CampaignAnalysisBatchRunResponseDto = {
  status: 'success' | 'failure';
  campaignId: string;
  scheduledCallIds: string[];
  batchId?: string;
  taskIds?: string[];
  error?: 'campaign_not_found' | 'analysis_plan_missing' | 'structured_output_missing';
};
export type CampaignStructuredOutputGenerateResponseDto = {
  /** Generated structured output template name. */
  name: string;
  /** Generated structured output template description. */
  description: string;
  /** Generated structured output schema serialized as a string. */
  schema: string;
  /** Generated analysis instructions for the structured output. */
  instructions: string;
  /** Generation timestamp returned by the analysis service. */
  createdAt: string;
};
export type TrunkType = 'inbound' | 'outbound';
export type SipTransport = 'auto' | 'udp' | 'tcp' | 'tls';
export type CampaignSipTrunkCreateRequestDto = {
  type: TrunkType;
  authUsername?: string | null;
  authPassword?: string | null;
  numbers: string[];
  allowedNumbers?: string[] | null;
  allowedAddresses?: string[] | null;
  address?: string | null;
  transport?: SipTransport;
};
export type SipTrunkResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: TrunkType;
  campaignId: string;
  sipTrunkId?: string | null;
  numbers: string[];
  address?: string | null;
  allowedAddresses?: string[] | null;
  transport: SipTransport;
};
export type CampaignsStopExceededLimitsResponseDto = {
  stoppedCampaignIds: string[];
  processedCompanies: number;
};
export type CustomerUpdateRequestDto = {
  number?: string;
  name?: string | null;
  gender?: ('male' | 'female') | null;
  attributes?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
};
export type AgentIdleStateRequestDto = {
  enabled: boolean;
  delayMs: number;
  messages: string[];
  customerSilenceMessages?: string[];
  customerEndCallMessages?: string[];
  customerReplyTimeoutSec?: number | null;
  customerSilenceThresholdSec?: number | null;
  customerMaxAttempts?: number | null;
};
export type AgentRequestDto = {
  llmProviderId: string;
  llmModelId?: string | null;
  llmCustomModelKey?: string | null;
  name: string;
  profileId?: string | null;
  languages: string[];
  voiceId: string;
  transcriberId: string;
  idleState?: AgentIdleStateRequestDto | null;
};
export type CallActionStatus = 'pending' | 'in-progress' | 'succeeded' | 'failed' | 'skipped';
export type CallActionDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  callId: string;
  status: CallActionStatus;
  toolId: string;
  rejectionReason?: string;
};
export type CallActionToolType = 'request-callback' | 'whatsapp-message-send';
export type CallActionRequestDto = {
  toolType: CallActionToolType;
  scheduledCallbackAt?: string;
  agentId?: string;
  input?: {
    [key: string]: string;
  };
  resend?: boolean;
};
export type CallCreateSystemRequestDto = {
  status: CallStatus;
  startedAt?: string;
  roomName?: string;
  recordingUrl?: string;
  /** Optional client-provided call id. When set, the call is created with this id instead of a generated one (e.g. websocket session_id used as the call id). */
  id?: string;
  customer: CustomerRequestDto;
  /** Either agentId or squadId must be provided */
  agentId?: string;
  /** Either agentId or squadId must be provided */
  squadId?: string;
  type: CallType;
};
export type SystemCampaignDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  companyId: string;
  status: CampaignStatus;
  title: string;
  type: CampaignType;
  description?: string | null;
  retryIntervalInMinutes?: number | null;
  retryMaxNumber?: number | null;
  retriesPerDay?: number | null;
  productDetails?: string | null;
  callSchedule?: CallScheduleDto;
  sipTrunks?: SipTrunkDto[];
  analysisPlan?: AnalysisPlanDto;
  structuredOutputs?: StructuredOutputDto[];
  tools?: ToolDto[];
  fileIds?: string[];
  reservedLimit: number;
  analysisTriggerType: AnalysisTriggerType;
  agentsCount: number;
  customersTotal?: number;
  squadId?: string;
  noiseProcessing: CampaignNoiseProcessingResponseDto;
  turnHandling: TurnHandlingResponseDto | null;
  speechPacing: SpeechPacingResponseDto | null;
  backgroundSounds?: CampaignBackgroundSoundsResponseDto | null;
  squad?: SquadDto | null;
  agents?: AgentDto[] | null;
};
export type CampaignCallListMetaDto = {
  hasMore: boolean;
  cursor: string | null;
  totalItems?: number;
};
export type CampaignCallListPaginatedDto = {
  data: CallDto[];
  meta: CampaignCallListMetaDto;
};
export type FileResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  status: object;
  fileName: string;
  size: number;
};
export type ExternalAgentDto = {
  id: string;
  name: string;
};
export type ExternalSquadDto = {
  id: string;
  name: string;
  agents: ExternalAgentDto[];
};
export type ExternalCampaignDto = {
  id: string;
  title: string;
  status: CampaignStatus;
  type: CampaignType;
  description: string | null;
  agents: ExternalAgentDto[];
  squad: ExternalSquadDto | null;
};
export type CampaignListItemDto = {
  id: string;
  title: string;
  status: CampaignStatus;
  type: CampaignType;
  createdAt: string;
  updatedAt: string;
  customersTotal: number;
  customersLeft: number;
  agentsCount: number;
};
export type CampaignListMetaDto = {
  hasMore: boolean;
  cursor: string | null;
  totalItems?: number;
};
export type CampaignListPaginatedDto = {
  data: CampaignListItemDto[];
  meta: CampaignListMetaDto;
};
export type CampaignMetricCallDurationResponseDto = {};
export type CallAccessTokenDto = {
  token: string;
  expiredAt: string;
  callId: string;
};
export type CallRecordingDto = {
  url: string;
  expiresAt: string;
  callId: string;
};
export type CustomerShortDto = {
  id: string;
  number?: string;
  name?: string | null;
  attributes?: object;
  campaignId?: string;
};
export type CallNotAnalyzedListDto = {
  id: string;
  analysisPrompt?: string;
  customer?: CustomerShortDto;
};
export type CustomerListItemDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  number?: string;
  name?: string | null;
  gender?: string | null;
  attributes?: object;
  metadata?: object;
  campaignId?: string;
  /** Whether the customer has at least one call */
  hasCalls: boolean;
};
export type CursorPaginationMetaDto = {
  hasMore: boolean;
  cursor: string | null;
};
export type CustomerListPaginatedDto = {
  data: CustomerListItemDto[];
  meta: CursorPaginationMetaDto;
};
export type AgentBackgroundSoundsRequestDto = {
  ambientSound?: AmbientSoundRequestDto | null;
  thinkingSounds?: ThinkingSoundRequestDto[];
};
export type BackgroundSoundType = 'ambient' | 'thinking';
export type BackgroundSoundResponseDto = {
  id: string;
  type: BackgroundSoundType;
  name: string;
  defaultVolume: number;
  isDefault: boolean;
  fileUrl: string;
};
export type BackgroundSoundCreateRequestDto = {
  uploadKey: string;
  name: string;
  type: BackgroundSoundType;
  defaultVolume: number;
};
export type BackgroundSoundUpdateRequestDto = {
  uploadKey?: string;
  name?: string;
  defaultVolume?: number;
};
export type BackgroundSoundUploadUrlResponseDto = {
  uploadUrl: string;
  uploadKey: string;
  expiresAt: string;
};
export type BackgroundSoundUploadUrlRequestDto = {
  type: BackgroundSoundType;
  mimeType: string;
  originalFilename: string;
  size: number;
};
export type ElevenLabsSettingsRequestDto = {
  minInterruptionWords?: number;
  minInterruptionDuration?: number;
  minEndpointingDelay?: number;
  maxEndpointingDelay?: number;
  model?: ElevenLabsTtsModel;
  similarityBoost?: number;
  stability?: number;
  useSpeakerBoost?: boolean;
  style?: number;
  language?: string;
};
export type PlayAiSettingsRequestDto = {
  minInterruptionWords?: number;
  minInterruptionDuration?: number;
  minEndpointingDelay?: number;
  maxEndpointingDelay?: number;
  model: PlayAiTtsModel;
  language?: string;
  sampleRate?: number;
};
export type HamsaSettingsRequestDto = {
  minInterruptionWords?: number;
  minInterruptionDuration?: number;
  minEndpointingDelay?: number;
  maxEndpointingDelay?: number;
  speaker: string;
  dialect: string;
  mulaw: boolean;
};
export type CustomVoiceSettingsRequestDto = {
  /** Custom provider name */
  provider: string;
  /** Voice ID */
  voiceId: string;
};
export type VoiceRequestDto = {
  name: string;
  previewUrl: string;
  /** Voice provider identifier. Can be one of the known providers (11labs, playai, hamsa) or any custom string. */
  provider: string;
  /** Optional pseudonym shown to end-users instead of the real provider name (e.g. "1punch" instead of "11labs"). */
  providerDisplayName?: string;
  /** This is the provider-specific ID that will be used. Ensure the Voice is present in your 11Labs Voice Library. */
  voiceId?: string;
  gender?: string;
  accent?: string;
  voiceSettings:
    | ElevenLabsSettingsRequestDto
    | PlayAiSettingsRequestDto
    | HamsaSettingsRequestDto
    | CustomVoiceSettingsRequestDto;
};
export type TranscriberRequestDto = {
  id?: string;
  provider: ProviderType;
  /** Optional pseudonym shown to end-users instead of the real provider name (e.g. "1punch" instead of "deepgram"). */
  providerDisplayName?: string;
  language: LanguageType;
};
export type DefaultSipSettingsDto = {
  type: TrunkType;
  authUsername?: string;
  authPassword?: string;
  numbers: string[];
  allowedNumbers?: string[] | null;
  allowedAddresses?: string[] | null;
  address?: string | null;
  transport?: SipTransport;
};
export type CompanyDto = {
  id: string;
  name: string;
  logo?: string | null;
  description?: string | null;
  industryType?: string | null;
  address?: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  users?: UserDto[];
  defaultOutboundSettings?: DefaultSipSettingsDto;
  defaultInboundSettings?: DefaultSipSettingsDto;
  voices?: VoiceDto[];
  transcribers?: TranscriberResponseDto[];
  llmProviders?: LlmProviderDto[];
};
export type UserRequestDto = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  role: UserRoles;
};
export type UsageUnitLimit = 'call-second' | 'llm-total-tokens' | 'stt-second' | 'tts-character';
export type UsageLimitSetItemDto = {
  unit: UsageUnitLimit;
  /** Monthly limit as stringified integer */
  limitPerMonth: string;
};
export type CreateCompanyRequestDto = {
  name: string;
  description?: string | null;
  logo?: string | null;
  users: UserRequestDto[];
  defaultOutboundSettings?: DefaultSipSettingsDto;
  defaultInboundSettings?: DefaultSipSettingsDto;
  limits?: UsageLimitSetItemDto[];
  /** Company-wide concurrent call limit */
  companyConcurrentLimit?: number;
  voiceIds?: string[];
  transcriberIds?: string[];
  llmProviderIds?: string[];
};
export type EditCompanyRequestDto = {
  name: string;
  description: string | null;
  logo: string | null;
  industryType?: string;
  address?: string;
  defaultOutboundSettings?: DefaultSipSettingsDto;
  defaultInboundSettings?: DefaultSipSettingsDto;
  voiceIds?: string[];
  transcriberIds?: string[];
  llmProviderIds?: string[];
};
export type CompanyApiKeyCreateResponseDto = {
  ok: boolean;
  apiKey: string;
};
export type AgentProfileCreateRequestDto = {
  name: string;
  prompt: string;
  firstMessage?: string | null;
  firstMessageInterruptionsEnabled?: boolean;
};
export type AgentProfileCreateAdminRequestDto = {
  name: string;
  prompt: string;
  firstMessage?: string | null;
  firstMessageInterruptionsEnabled?: boolean;
  type?: AgentProfileType;
};
export type AgentProfileEditRequestDto = {
  name?: string;
  prompt?: string;
  firstMessage?: string | null;
  firstMessageInterruptionsEnabled?: boolean;
  taskFlow?: TaskFlowDto | null;
};
export type CompanyOverviewResponseDto = {
  ongoingCalls: number | null;
  runningCampaigns: number | null;
  inactiveCampaigns: number | null;
  totalCampaigns: number | null;
};
export type UsageLimitDetailDto = {
  unit: UsageUnitLimit;
  allowed: boolean;
  limit: string;
  used: string;
  remaining: string;
  delta: number;
};
export type ConcurrentLimitResponseDto = {
  limit: number;
  activeCalls: number;
};
export type RemainingLimitResponseDto = {
  allowed: boolean;
  companyId: string;
  limits: UsageLimitDetailDto[];
  concurrent?: ConcurrentLimitResponseDto | null;
};
export type UsageLimitResponseDto = {
  unit: object;
  limitPerMonth: string;
};
export type UsageLimitSetRequestDto = {
  limits: UsageLimitSetItemDto[];
};
export type CompanyVoicesSetRequestDto = {
  voiceIds: string[];
};
export type CompanyTranscribersSetRequestDto = {
  transcriberIds: string[];
};
export type CompanyLlmProvidersSetRequestDto = {
  llmProviderIds: string[];
};
export type ConcurrentLimitSetResponseDto = {
  companyConcurrentLimit: number;
};
export type ConcurrentLimitSetRequestDto = {
  /** Company-wide concurrent call limit */
  companyConcurrentLimit: number;
};
export type UnitWeightsResponseDto = {
  id: string;
  sourceUnit: object;
  limitUnit: object;
  weight: number;
};
export type UnitWeightSetItemDto = {
  /** UUID of the unit weight record */
  id: string;
  /** Weight multiplier */
  weight: number;
};
export type UnitWeightsSetRequestDto = {
  weights: UnitWeightSetItemDto[];
};
export type PostCallMessageConditionDto = {
  /** Analysis-summary field name to test. */
  field: string;
  operator: 'equals' | 'not_equals' | 'contains' | 'exists' | 'not_exists';
  /** Compared as a string. Required for equals/not_equals/contains; ignored otherwise. */
  value?: string;
};
export type CampaignPostCallMessageResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  campaignId: string;
  isEnabled: boolean;
  order: number;
  channel: 'whatsapp';
  conditions: PostCallMessageConditionDto[];
  template: string;
};
export type CampaignPostCallMessageCreateRequestDto = {
  /** Defaults to true. */
  isEnabled?: boolean;
  /** Send order among matched rules; lower runs first. Default 0. */
  order?: number;
  /** Defaults to whatsapp. */
  channel?: 'whatsapp';
  /** AND-joined; empty = always send. */
  conditions: PostCallMessageConditionDto[];
  /** Message body with {{path}} placeholders (e.g. {{customer.name}}). */
  template: string;
};
export type CampaignPostCallMessageUpdateRequestDto = {
  isEnabled?: boolean;
  order?: number;
  channel?: 'whatsapp';
  conditions?: PostCallMessageConditionDto[];
  template?: string;
};
export type FileCreateRequestDto = {
  fileName: string;
  agentId?: string;
  campaignId?: string;
};
export type SquadCreateRequestDto = {
  name: string;
  description?: string;
};
export type SquadAgentUpdateRequestDto = {
  llmProviderId: string;
  llmModelId?: string | null;
  llmCustomModelKey?: string | null;
  name: string;
  profileId?: string | null;
  languages: string[];
  voiceId: string;
  transcriberId: string;
  idleState?: AgentIdleStateRequestDto | null;
  isDefault?: boolean;
};
export type SquadAgentDeleteResponseDto = {
  ok: boolean;
  defaultAgentId?: string;
};
export type HandoffRuleMessagesRequestDto = {
  start?: string[];
  delayed?: string[];
  complete?: string[];
  failed?: string[];
};
export type ContextPropagationPlanRequestDto = {
  type: ContextPropagationPlanType;
  maxMessages?: number;
};
export type HandoffRuleRequestDto = {
  name?: string;
  description?: string;
  fromAgentId: string;
  toAgentId: string;
  messages?: HandoffRuleMessagesRequestDto;
  contextPropagationPlan?: ContextPropagationPlanRequestDto;
  variableExtractionPlan?: object;
};
export type StructuredOutputCreateRequestDto = {
  name: string;
  description: string;
  instructions?: string | null;
  schema: object;
};
export type StructuredOutputUpdateRequestDto = {
  name?: string;
  description?: string;
  instructions?: string | null;
  schema?: object;
};
export type CampaignStructuredOutputAttachRequestDto = {
  structuredOutputId: string;
};
export type ToolUpdateRequestDto = {
  /** Agent ID to attach tool to agent instead of campaign */
  agentId?: string;
  isAsync: boolean;
  messageTemplate?: string | null;
  phoneNumbers?: string[] | null;
  mcpName?: string | null;
  mcpServerConfig?: object;
  genderSettings?: object | null;
};
export type WebhookHeaderItemDto = {
  key: string;
  value: string;
};
export type WebhookAuthConfigMaskedDto = {
  masked: boolean;
};
export type WebhookSuccessCriteriaItemDto = {
  path: string;
  equals: string;
  errorPath?: string;
};
export type CampaignWebhookResponseDto = {
  id: string;
  campaignId: string;
  name: string;
  isEnabled: boolean;
  triggerOn: string;
  url: string;
  httpMethod: object;
  headers?: WebhookHeaderItemDto[] | null;
  bodyTemplate?: object | null;
  authType: object;
  authConfig?: WebhookAuthConfigMaskedDto | null;
  timeoutMs: number;
  maxRetries: number;
  ignoreSslErrors: boolean;
  successCriteria?: WebhookSuccessCriteriaItemDto | null;
  createdAt: string;
  updatedAt: string;
};
export type WebhookHeaderDto = {
  key: string;
  value: string;
};
export type WebhookSuccessCriteriaDto = {
  /** Dot-path into the JSON response body, e.g. "AckMessage.Status". */
  path: string;
  /** Value at `path` that marks an application-level success (compared as a string). */
  equals: string;
  /** Dot-path to a human-readable error detail, surfaced into the delivery log. */
  errorPath?: string;
};
export type CampaignWebhookCreateRequestDto = {
  name: string;
  isEnabled?: boolean;
  url: string;
  httpMethod?: 'POST' | 'GET';
  headers?: WebhookHeaderDto[];
  bodyTemplate?: object;
  authType?: 'none' | 'basic' | 'bearer';
  authConfig?: object;
  /** Skip TLS certificate validation for the target (self-signed / internal hosts). */
  ignoreSslErrors?: boolean;
  /** Retries after the first attempt (0 = single attempt). Default 3. */
  maxRetries?: number;
  /** Application-level success rule against the JSON response body. Omit → success is decided by the HTTP status code only. */
  successCriteria?: WebhookSuccessCriteriaDto;
};
export type CampaignWebhookUpdateRequestDto = {
  name?: string;
  isEnabled?: boolean;
  url?: string;
  httpMethod?: 'POST' | 'GET';
  headers?: WebhookHeaderDto[];
  bodyTemplate?: object;
  authType?: 'none' | 'basic' | 'bearer';
  authConfig?: object;
  /** Skip TLS certificate validation for the target (self-signed / internal hosts). */
  ignoreSslErrors?: boolean;
  /** Retries after the first attempt (0 = single attempt). */
  maxRetries?: number;
  /** Application-level success rule against the JSON response body. Pass null to clear it (revert to HTTP-status-only). */
  successCriteria?: WebhookSuccessCriteriaDto | null;
};
export type PeriodDto = {
  start: string;
  end: string;
};
export type UsageProviderDto = {
  provider: string;
  period?: PeriodDto;
  result: object;
};
export type UsageResponseDto = {
  providers: UsageProviderDto[];
};
export const {
  useAppControllerGetHelloQuery,
  useMetricsControllerWebhookQuery,
  useRefreshTokensControllerRefreshTokenUserMutation,
  useRefreshTokensControllerRefreshTokenAdminMutation,
  useSignInControllerSignInUserMutation,
  useSignInControllerSignInAdminMutation,
  useApiKeyControllerGetSystemApiKeyInfoQuery,
  useForgotPasswordControllerForgotPasswordMutation,
  useResetPasswordControllerResetPasswordMutation,
  useUserMeControllerUserMeQuery,
  useGetUsersListControllerGetUsersListQuery,
  useEditUserControllerEditUserMutation,
  useUserCreateControllerCreateUserMutation,
  useAdminMeControllerAdminMeQuery,
  useAnalysisStaleSweepControllerSystemAnalysisStaleSweepMutation,
  useCallAnalysisCreateControllerSystemCreateCallAnalysisMutation,
  useCallSentimentCreateControllerCreateCallSentimentMutation,
  useCallUpdateControllerSystemCallUpdateMutation,
  useCallControllerSystemGetCallByIdQuery,
  useCallSupervisorModeControllerSetSupervisorModeMutation,
  useCallStaleSweepControllerSystemStaleSweepMutation,
  useCampaignTestCallCreateControllerTestCallCreateMutation,
  useCampaignCallListControllerCallListQuery,
  useCampaignTestCallCreateControllerExternalTestCallCreateMutation,
  useCallCreateExternalControllerCampaignOutboundCallMutation,
  useCampaignCallHangupControllerCampaignCallHangupMutation,
  useCampaignCallHangupControllerExternalCampaignCallHangupMutation,
  useCampaignCloneSystemControllerCloneCampaignMutation,
  useCampaignCreateControllerCampaignCreateMutation,
  useCampaignListControllerCampaignListQuery,
  useCampaignDeleteControllerDeleteCampaignMutation,
  useCampaignUpdateControllerCampaignUpdateMutation,
  useCampaignControllerCampaignQuery,
  useCampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerMutation,
  useCampaignAnalysisBatchRunControllerSystemRunAnalysisBatchMutation,
  useCampaignStructuredOutputGenerateControllerGenerateMutation,
  useCampaignOutboundCallsProcessControllerSystemOutboundCallsProcessMutation,
  useCampaignCompletionSweepControllerSystemCompletionSweepMutation,
  useCampaignRunControllerCampaignRunMutation,
  useCampaignSipTrunkCreateControllerCampaignCreateMutation,
  useCampaignSipTrunkControllerGetSipTrunkQuery,
  useCampaignStopControllerCampaignStopMutation,
  useCampaignsStopExceededLimitsControllerStopExceededLimitsMutation,
  useCustomerUpdateControllerUpdateCustomerMutation,
  useCampaignAgentCreateControllerExecuteMutation,
  useCampaignAgentListControllerListQuery,
  useCampaignAgentUpdateControllerExecuteMutation,
  useCampaignAgentDeleteControllerExecuteMutation,
  useCallActionCreateControllerSystemCallActionCreateMutation,
  useCallCreateSystemControllerSystemCampaignCallCreateMutation,
  useCallControllerGetCallByIdQuery,
  useCampaignControllerSystemCampaignQuery,
  useCampaignCallControllerCallQuery,
  useCampaignCallListPaginatedControllerCallListPaginatedQuery,
  useCampaignFileListControllerListQuery,
  useCampaignListControllerExternalCampaignListQuery,
  useCampaignListPaginatedControllerGetCampaignListPaginatedQuery,
  useCampaignMetricCallDurationControllerCalculateCallDurationIqrQuery,
  useCampaignReportControllerUserCampaignsReportQuery,
  useCampaignReportControllerUserCampaignReportQuery,
  useCampaignReportControllerAdminCampaignsReportQuery,
  useCampaignReportControllerAdminCampaignReportQuery,
  useCallAccessTokenControllerGetCallAccessTokenQuery,
  useCallAccessTokenControllerGetExternalCallAccessTokenQuery,
  useCallRecordingControllerGetCallRecordingQuery,
  useCampaignActiveCallPollControllerExternalCampaignActiveCallPollQuery,
  useCallNotAnalyzedListControllerSystemGetNotAnalyzedCallsQuery,
  useCustomerListPaginatedControllerGetCustomerListPaginatedQuery,
  useBackgroundSoundAgentSettingsUpdateControllerExecuteMutation,
  useBackgroundSoundCreateControllerCreateMutation,
  useBackgroundSoundListControllerAdminListQuery,
  useBackgroundSoundDeleteControllerDeleteMutation,
  useBackgroundSoundUpdateControllerUpdateMutation,
  useBackgroundSoundUploadUrlControllerCreateUploadUrlMutation,
  useBackgroundSoundListControllerListQuery,
  useVoiceListControllerVoiceListQuery,
  useVoiceListSystemControllerGetAllVoicesQuery,
  useVoiceControllerGetVoiceQuery,
  useVoiceDeleteControllerDeleteVoiceMutation,
  useVoiceEditControllerEditVoiceMutation,
  useVoiceSystemControllerGetVoiceQuery,
  useVoiceEditSystemControllerEditVoiceMutation,
  useVoiceCreateControllerCreateVoiceMutation,
  useVoiceCreateSystemControllerCreateVoiceMutation,
  useVoiceDeleteSystemControllerDeleteVoiceMutation,
  useTranscriberListControllerTranscriberListQuery,
  useTranscriberListControllerGetTranscriberQuery,
  useTranscriberListControllerAdminTranscriberListQuery,
  useTranscriberCreateControllerCreateTranscriberMutation,
  useTranscriberControllerGetTranscriberQuery,
  useTranscriberDeleteControllerDeleteTranscriberMutation,
  useTranscriberEditControllerEditTranscriberMutation,
  useCreateCompanyControllerCreateCompanyMutation,
  useCompanyControllerGetCompanyQuery,
  useCompanyControllerGetCompanyAsAdminQuery,
  useEditCompanyControllerEditCompanyMutation,
  useGetAllCompanyIdsControllerGetAllCompanyIdsQuery,
  useCompanyApiKeyCreateControllerApiKeyCreateMutation,
  useCompanyApiKeyRevokeControllerApiKeyRevokeMutation,
  useAgentProfileCreateControllerAgentProfileCreateForUsersMutation,
  useAgentProfileListControllerAgentProfileListForUsersQuery,
  useAgentProfileCreateControllerAgentProfileCreateForManagersMutation,
  useAgentProfileListControllerAgentProfileListForAdminsQuery,
  useAgentProfileEditControllerAgentProfileEditForUsersMutation,
  useAgentProfileDeleteControllerAgentProfileDeleteForUsersMutation,
  useAgentProfileEditControllerAgentProfileEditForManagersMutation,
  useAgentProfileDeleteControllerAgentProfileDeleteForManagersMutation,
  useCompanyOverviewControllerGetCompanyOverviewQuery,
  useCompanyListControllerCompanyListQuery,
  useUsageLimitControllerUsageLimitsQuery,
  useUsageLimitControllerAdminUsageLimitsQuery,
  useUsageLimitSetControllerSetLimitsMutation,
  useUsageLimitControllerSystemUsageLimitsQuery,
  useCompanyVoicesSetControllerSetCompanyVoicesMutation,
  useCompanyTranscribersSetControllerSetCompanyTranscribersMutation,
  useCompanyLlmProvidersSetControllerSetCompanyLlmProvidersMutation,
  useConcurrentLimitSetControllerSetConcurrentLimitMutation,
  useUnitWeightsControllerGetUnitWeightsQuery,
  useUnitWeightsSetControllerSetUnitWeightsMutation,
  useLivekitControllerWebhookMutation,
  useCampaignPostCallMessageCreateControllerCreateMutation,
  useCampaignPostCallMessagesControllerListQuery,
  useCampaignPostCallMessageUpdateControllerUpdateMutation,
  useCampaignPostCallMessageDeleteControllerDeleteMutation,
  useMessageDeliverySweepControllerSystemDeliverySweepMutation,
  useMessageDeliveryUpdateControllerWebhookMutation,
  useFileCreateControllerCreateMutation,
  useFileListControllerListQuery,
  useFileDeleteControllerDeleteMutation,
  useFileControllerGetQuery,
  useSquadCreateControllerExecuteMutation,
  useSquadDeleteControllerExecuteMutation,
  useSquadAgentCreateControllerExecuteMutation,
  useSquadAgentUpdateControllerExecuteMutation,
  useSquadAgentDeleteControllerExecuteMutation,
  useHandoffRuleCreateControllerExecuteMutation,
  useStructuredOutputCreateControllerCreateMutation,
  useStructuredOutputListControllerListQuery,
  useStructuredOutputUpdateControllerUpdateMutation,
  useStructuredOutputDeleteControllerDeleteMutation,
  useStructuredOutputControllerGetQuery,
  useStructuredOutputTemplateListControllerListQuery,
  useStructuredOutputTemplateControllerGetQuery,
  useCampaignStructuredOutputAttachControllerAttachMutation,
  useCampaignStructuredOutputListControllerListQuery,
  useCampaignStructuredOutputDetachControllerDetachMutation,
  useToolCreateControllerCreateCampaignToolMutation,
  useToolListControllerCampaignToolListQuery,
  useToolCreateControllerCreateAgentToolMutation,
  useToolListControllerAgentTollListQuery,
  useToolUpdateControllerCreateCampaignToolMutation,
  useToolDeleteControllerCreateCampaignToolMutation,
  useToolUpdateControllerCreateAgentToolMutation,
  useToolDeleteControllerCreateAgentToolMutation,
  useLlmProviderListControllerProviderListQuery,
  useLlmProviderListControllerAdminProviderListQuery,
  useLlmModelListControllerModelListQuery,
  useLlmModelListControllerAdminModelListQuery,
  useCampaignWebhookCreateControllerCreateMutation,
  useCampaignWebhooksControllerListQuery,
  useCampaignWebhookUpdateControllerUpdateMutation,
  useCampaignWebhookDeleteControllerDeleteMutation,
  useCampaignWebhookDispatchControllerManualDispatchMutation,
  useCampaignWebhookDispatchControllerSystemDispatchMutation,
  useWebhookDeliverySweepControllerSystemDeliverySweepMutation,
  useHealthControllerCheckQuery,
  useUsageMonitoringControllerGetUsageQuery,
} = injectedRtkApi;
